import React, { Component } from "react";
import { Link, useHistory } from "react-router-dom";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import Select from "react-select";
import { dateUtils, dateFieldCombo } from "../../common/DateUtils";
import moment from "moment";
import { cpfMask, cnpjMask, cepMask, foneMask, moneyMask } from '../../common/Mask'
import CurrencyInput from 'react-currency-input-field';

const status = [
  { label: "Não Iniciada", value: "1" },
  { label: "Aprovada", value: "2" },
  { label: "Em Produção", value: "3" },
  { label: "Aguardando Pagamento", value: "4" },
  { label: "Aguardando Cliente", value: "5" },
  { label: "Pago", value: "6" },
  { label: "Em Lavagem", value: "7" },
  { label: "Em Emgomadeira", value: "8" },
];

const tipos = [
  { label: "Lavar/Passa", value: "1" },
  { label: "Lavar", value: "2" },
  { label: "Passar", value: "3" },
];

const prioridade = [
  { label: "Normal", value: "1" },
  { label: "Média", value: "2" },
  { label: "Alta", value: "3" },
];

const ufs = [
  {label:'AC', value:'AC'},
  {label:'AL', value:'AL'},
  {label:'AP', value:'AP'},
  {label:'AM', value:'AM'},
  {label:'BA', value:'BA'},
  {label:'CE', value:'CE'},
  {label:'DF', value:'DF'},
  {label:'GO', value:'GO'},
  {label:'MA', value:'MA'},
  {label:'MT', value:'MT'},
  {label:'MG', value:'MG'},
  {label:'PA', value:'PA'},
  {label:'PB', value:'PB'},
  {label:'PR', value:'PR'},
  {label:'PE', value:'PE'},
  {label:'PI', value:'PI'},
  {label:'RJ', value:'RJ'},
  {label:'RN', value:'RN'},
  {label:'RS', value:'RS'},
  {label:'RO', value:'RO'},
  {label:'SC', value:'SC'},
  {label:'SP', value:'SP'},
  {label:'SE', value:'SE'},
  {label:'TO', value:'TO'},
]


class Vendas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      todos: [],
      filtros: [],
      listaStatus: [],
      statusDefault: [],
      listatipos: [],
      listaPrioridade: prioridade,
      tiposDefault: [],
      funcionarios: [],
      funcionarioDefault: [],
      precificacao: [],
      itens_carrinho: [],
      itens_grupo: [],
      pedido: [],
      motivoDefault:[],
      motivos:[],
      itens_combo:[],
      id: "",
      os: "",
      nivel: "",
      status: "",
      emissao: "",
      emissaoh: "",
      entrega: "",
      taxa:0,
      aprovador: "",
      aprovacao: "",
      aprovacaoh: "",
      concluidor: "",
      conclusao: "",
      conclusaoh: "",
      meioPagamento: "",
      meioPagamentos: [],
      meioPagamentoDefaul: [],      
      totalAberto: 0,
      totalPago: 0,
      item_pagos: [],
      cliente_atendimento:"",
      venda_atendimento:"",
      data_atendimento:"",
      hora_atendimento:"",
      motivo_atendimento:"",
      descricao_atendimento:"",
      eventos_atendimento:[],
      valor_pago: 0,
      cliente: "",
      cnpjcpf:"",
      razao:"",
      fantasia:"",
      email:"",
      fone:"",
      cep: "",
      logradouro: "",
      numero: "",
      complemento: "",
      uf: "",
      ufs:ufs,
      ufDefault:[],
      cidade: "",
      bairro: "",
      fone: "",
      isCustomerValide:false,
      funcionario: "",
      acrescimo: "",
      desconto: "",
      total: "",
      item_precificao: "",
      item_tipo: "",
      item_grupo: "",
      item_recurso: "",
      item_quantidade: "",
      item_unitario: "",
      item_total: "",
      total_quantidade: 0,
      total_desconto: 0,
      total_acrescimo: 0,
      total_geral: 0,
      servicos: [],
      servicoDefault: [],
      meioPagamentos: [],
      observacao: "",
      eNovoOuEdicao: false,
      totalizados: "",
      isLoading: true,
      isFiltroPronto: false,
    };

    this.novoCliente = this.novoCliente.bind(this)
    this.salvarNovoCliente = this.salvarNovoCliente.bind(this)
    this.onChargeCep    = this.onChargeCep.bind(this); 
    this.novo = this.novo.bind(this);
    this.imprimir = this.imprimir.bind(this);
    this.priorizar = this.priorizar.bind(this);
    this.nivel = this.nivel.bind(this);
    this.cancelar = this.cancelar.bind(this);
    this.abre = this.abre.bind(this);
    this.adicionar = this.adicionar.bind(this);
    this.excluir = this.excluir.bind(this);
    this.aprovacao = this.aprovacao.bind(this);
    this.produzido = this.produzido.bind(this);
    this.cancelar = this.cancelar.bind(this);
    this.producao = this.producao.bind(this);
    this.concluir = this.concluir.bind(this)
    this.lancamentos = this.lancamentos.bind(this);
    this.lancar = this.lancar.bind(this);
    this.pagar = this.pagar.bind(this);
    this.atendimento = this.atendimento.bind(this)
    this.salvarAtendimento = this.salvarAtendimento.bind(this)
    this.opcaoMenu = this.opcaoMenu.bind(this);
    this.onChangeCliente = this.onChangeCliente.bind(this);
    this.onChangeRecursoCarrinho = this.onChangeRecursoCarrinho.bind(this);
    this.handleFiltroGrid = this.handleFiltroGrid.bind(this);
    this.statusFilter = this.statusFilter.bind(this);
    this.nivelFilter = this.nivelFilter.bind(this);
    this.carregaCombo = this.carregaCombo.bind(this)
    this.filtroPronto = this.filtroPronto.bind(this);
  }

  async Loading(isLoading) {
    this.setState({ isLoading: isLoading });
  }

  async componentDidMount() {
    const token = sessionStorage.getItem("token");
    const grupo = sessionStorage.getItem("grupo");
    this.setState({ isCustomerValide: false })
    const permissoes = await api
      .get(`/api/permissao/${grupo}`, {
        headers: {
          "x-access-token": token,
        },
      })
      .catch((e) => {
        this.Loading(false);
      });

    const empresaVendas = permissoes.data.filter(function (value) {
      return value.idmenu == 4;
    });
    if (
      empresaVendas.length > 0 &&
      empresaVendas[0].permissao.indexOf("VER") < 0
    )
      return this.props.history.push("/index");

    await api
      .get("/api/vendas", {
        headers: {
          "x-access-token": token,
        },
      })
      .then((response) => {
        this.Loading(false);
        const data = {
          todos: 0,
          naoInicia: 0,
          aprovadas: 0,
          producao: 0,
          pronto:0,
          pagamento: 0,
        };

        const dados = response.data.sort(function(a,b){
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.emissao) - new Date(a.emissao);
        });

        dados.forEach((pedidos) => {
          data.todos = data.todos + 1;
          data.naoInicia =
            pedidos.status == 1 ? data.naoInicia + 1 : data.naoInicia;
          data.aprovadas =
            pedidos.status == 2 ? data.aprovadas + 1 : data.aprovadas;
          data.producao =
            pedidos.status == 3 ? data.producao + 1 : data.producao;
          data.pronto =
            pedidos.status == 4 || pedidos.status == 5 ? data.pronto + 1 : data.pronto;
          data.pagamento =
            pedidos.status == 6 ? data.pagamento + 1 : data.pagamento;
        });

        this.setState({
          items: dados,
          filtros: dados,
          totalizados: data,
        });
      })
      .catch((e) => {
        this.Loading(false);
        toast.error("Ops! Error:" + e);
      });
    this.Loading(false);
    this.setState({ listaPrioridade: prioridade });
  }

 

  novoCliente = async () => {
    
    this.setState({
        cnpjcpf:'',
        razao:'',
        fantasia:'',                           
        cep:'',
        endereco:'',
        numero:'',
        complemento:'',
        uf:'',
        ufs:[],
        ufDefault:[],
        cidade:'',
        bairro:'',
        fone:'',
        email:'',
        isCustomerValide: false 
    });

  }

  salvarNovoCliente = async () => {
    this.Loading(true);
    
    const token = sessionStorage.getItem("token");
    const pessoa = sessionStorage.getItem("pessoaid");
    const grupo = sessionStorage.getItem("grupo");

    const { cnpjcpf, razao, fantasia, cep, endereco, numero, complemento, uf, cidade, bairro, fone, email } = this.state
    if(!cnpjcpf || !razao || !fantasia || !fone ) {
      this.Loading(false);
      this.setState({ isCustomerValide: true })
      return toast.error('Informe os dados de cnpj ou cpf, razão ou nome, fantaisa ou apelido e um número de telefone para contato.')
    }
      
    const permissoes = await api.get(`/api/permissao/${grupo}`, {
        headers: {
            'x-access-token':token,
        }
    });       

    const empresaPessoa        = permissoes.data.filter(function(value){ return value.idmenu  == 3  })

    if( empresaPessoa.length > 0 && empresaPessoa[0].permissao.indexOf('INSERIR') < 0 ) {
      this.Loading(false);
      return toast.error('O usuário sem permissão.')
    }

    await api.post('/api/pessoa',{ cnpjcpf, razao, fantasia, tipo:1, cep, endereco, numero, complemento, uf, cidade, bairro, fone, email }, {
      headers: {
          'x-access-token':token,
      }
    }).then(async response => {
      window.location.href = "/venda";    
    })
  };

  onChargeCep = async( cep ) => {
    console.log(cep)
    this.setState({cep: cep});
    this.buscarCep(cep);    
  }

  buscarCep = async (value) => {

    const token    = sessionStorage.getItem('token');
   
    const cep = value.replace('-','')
    if(cep.length == 8) {            
        fetch(`http://viacep.com.br/ws/${cep}/json/`, {mode: 'cors'})
        .then((res) => res.json())
        .then((data) => {
            if (data.hasOwnProperty("erro")) {
                toast.error('Cep Informado não encontrado.')
            } else {

                console.log(data)
                this.setState({
                    endereco: data.logradouro,
                    cidade: data.localidade,
                    bairro: data.bairro,
                    uf: data.uf,
                    ufDefault:[{label: data.uf, value: data.uf }]
                })
            }
        })
        .catch(err => console.log(err));
        /*
        .then((data) => {
            console.log(data)
              /*if (data.hasOwnProperty("erro")) {
                  this.setState({
                    cep:data.cep,
                    endereco:data.endereco,
                    numero:data.numero,
                    complemento:'',
                    uf:data.uf,
                    ufs:[],
                    ufDefault:[],
                    cidade:data.cidade,
                    bairro:data.bairro,
                  });
                  alert('Cep não existente');
              } else {
                  this.setState({
                    cep:data.cep,
                    endereco:data.endereco,
                    numero:data.numero,
                    complemento:'',
                    uf:data.uf,
                    ufs:[],
                    ufDefault:[],
                    cidade:data.cidade,
                    bairro:data.bairro,

                  });
              }
          })
          .catch(err => console.log(err));*/
      }
  }

  novo = async () => {
    this.Loading(true);

    const token = sessionStorage.getItem("token");
    const pessoa = sessionStorage.getItem("pessoaid");
    const grupo = sessionStorage.getItem("grupo");

    const permissoes = await api
      .get(`/api/permissao/${grupo}`, {
        headers: {
          "x-access-token": token,
        },
      })
      .catch((e) => {
        this.Loading(false);
        toast.error("Problemas na permissão.");
      });

    const empresaVendas = permissoes.data.filter(function (value) {
      return value.idmenu == 4;
    });
    if (
      empresaVendas.length > 0 &&
      empresaVendas[0].permissao.indexOf("INSERIR") < 0
    )
      return toast.error("O usuário sem permissão.");

    const listarPessoas = await api
      .get("/api/pessoa", {
        headers: {
          "x-access-token": token,
        },
      })
      .catch((e) => {
        this.Loading(false);
        toast.error("Problemas ao listar as pessoas.");
      });

    const listarServico = await api
      .get("/api/servico", {
        headers: {
          "x-access-token": token,
        },
      })
      .catch((e) => {
        this.Loading(false);
        toast.error("Problemas ao listar as serviços.");
      });

    const clientes = [];
    listarPessoas.data.forEach((element) => {
      if (element.tipo === 1)
        clientes.push({ value: element.id, label: element.razao });
    });
    const servicos = [];
    listarServico.data.forEach((element) => {
      servicos.push({
        value: element.id,
        label: element.codigo + " " + element.nome,
      });
    });
    const atendentes = [];
    const atendenteDefault = [];
    listarPessoas.data.forEach((element) => {
      if (pessoa == element.id)
        atendenteDefault.push({ value: element.id, label: element.razao });
      atendentes.push({ value: element.id, label: element.razao });
    });

    this.Loading(false);
    let hoje = new Date();
    this.setState({
      id: "",
      os: moment(hoje).format("YYMMDDHHmmss"),
      status: 1 /* Pendente */,
      listaStatus: status,
      statusDefault: [status[0]],
      listatipos: tipos,
      tiposDefault: [tipos[0]],
      emissao: moment(hoje).format("YYYY-MM-DD"),
      emissaoh: moment(hoje).format("HH:mm"),
      entrega: moment(hoje.setDate(hoje.getDate() + 2)).format("YYYY-MM-DD"),
      taxa:0,
      clientes: clientes,
      clienteDefault: [],
      funcionario: pessoa,
      funcionarios: atendentes,
      funcionarioDefault: atendenteDefault,
      servicos: servicos,
      servicoDefault: [],
      itens_carrinho: [],
      item_grupo: "",
      item_tipo: "",
      item_recurso: "",
      item_quantidade: "",
      item_unitario: "",
      item_total: "",
      total_quantidade: 0,
      total_desconto: 0,
      total_acrescimo: 0,
      total_geral: 0,
      meioPagamento: "",
      meioPagamentos: [],
      meioPagamentoDefaul: [],
      totalAberto: 0,
      totalPago: 0,
      item_pagos: [],
      valor_pago: 0,
      cep: "",
      logradouro: "",
      numero: "",
      complemento: "",
      uf: "",
      cidade: "",
      bairro: "",
      fone: "",
      observacao: "",
      eNovoOuEdicao: true,
    });
  };

  abre = async (id) => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");
    const pessoa = sessionStorage.getItem("pessoaid");
    const grupo = sessionStorage.getItem("grupo");

    var carrinho = this.state.itens_carrinho ? this.state.itens_carrinho : [];
    var items_grupo = this.state.itens_grupo
      ? this.state.itens_grupo
      : new Object();

    const permissoes = await api
      .get(`/api/permissao/${grupo}`, {
        headers: {
          "x-access-token": token,
        },
      })
      .catch((e) => {
        this.Loading(false);
        toast.error("Problemas ao listar as pessoas.");
      });

    const empresaVendas = permissoes.data.filter(function (value) {
      return value.idmenu == 4;
    });
    if (
      empresaVendas.length > 0 &&
      empresaVendas[0].permissao.indexOf("ALTERAR") < 0
    )
      return toast.error("O usuário sem permissão.");

    try {
      const vendas = await api
        .get(`/api/vendas/${id}`, {
          headers: {
            "x-access-token": token,
          },
        })
        .catch((err) => {
          this.Loading(false);
          toast.error("Error:" + err);
        });

      const header = vendas.data[0];
      const itens = vendas.data[1];

      const listarPessoas = await api
        .get("/api/pessoa", {
          headers: {
            "x-access-token": token,
          },
        })
        .catch((err) => {
          this.Loading(false);
          toast.error("Error:" + err);
        });

      const listarServico = await api
        .get("/api/servico", {
          headers: {
            "x-access-token": token,
          },
        })
        .catch((err) => {
          this.Loading(false);
          toast.error("Error:" + err);
        });

      const endereco = {
        cep: "",
        logradouro: "",
        numero: "",
        complemento: "",
        uf: "",
        cidade: "",
        bairro: "",
        fone: "",
      };

      const clientes = [];
      const clienteDefault = [];
      listarPessoas.data.forEach((element) => {
        if (element.tipo === 1)
          clientes.push({ value: element.id, label: element.razao });
        if (header[0].cliente == element.id) {
          clienteDefault.push({ value: element.id, label: element.razao });
          endereco.cep = element.cep ? element.cep : "";
          endereco.logradouro = element.endereco ? element.endereco : "";
          endereco.numero = element.numero ? element.numero : "";
          endereco.complemento = element.complemento ? element.complemento : "";
          endereco.uf = element.uf ? element.uf : "";
          endereco.cidade = element.cidade ? element.cidade : "";
          endereco.bairro = element.bairro ? element.bairro : "";
          endereco.fone = element.fone ? element.fone : "";
        }
      });
      const servicos = [];
      listarServico.data.forEach((element) => {
        servicos.push({
          value: element.id,
          label: element.codigo + " " + element.nome,
        });
      });
      const atendentes = [];
      const atendenteDefault = [];
      listarPessoas.data.forEach((element) => {
        if (pessoa == element.id)
          atendenteDefault.push({ value: element.id, label: element.razao });
        if (vendas.data[0].funcionario == element.id)
          atendenteDefault.push({ value: element.id, label: element.razao });
      });

     

      var quantidade = 0;
      var desconto = 0;
      var acrescimo = 0;
      var total = 0;

      for (let index = 0; index < itens.length; index++) {
        const element = itens[index];

        carrinho.push({
          id: element.id,
          nmgrupo: element.nmgrupo,
          grupo: element.idgrupo,
          nome: element.nome,
          tipo: element.tipo,
          recurso: element.idservico,
          quantidade: element.quantidade,
          desconto: element.desconto,
          acrescimo: element.acrescimo,
          preco: element.preco,
          total: Number(element.quantidade) * Number(element.preco),
        });
      }

     
      this.Loading(false);
      this.setState({
        items: itens,
        todos: [],
        precificacao: [],
        itens_carrinho: carrinho,
        itens_grupo: items_grupo,
        id: header[0].id,
        os: header[0].numero,
        nivel: header[0].nivel,
        status: header[0].status,
        listaStatus: status,
        statusDefault: [status[Number(header[0].status) - 1]],
        emissao: moment(header[0].emissao).format("YYYY-MM-DD"),
        emissaoh: header[0].emissaoh.split(".")[0],
        entrega: moment(header[0].entrega).format("YYYY-MM-DD"),
        taxa:header[0].taxa,
        aprovador: header[0].aprovador,
        aprovacao: header[0].aprovacao,
        aprovacaoh: header[0].aprovacaoh,
        concluidor: header[0].concluidor,
        conclusao: header[0].conclusao,
        conclusaoh: header[0].conclusaoh,
        meiopagamento: header[0].meiopagamento,
        cliente: header[0].cliente,
        clientes: clientes,
        clienteDefault: clienteDefault,
        servicos: servicos,
        meioPagamento: "",
        meioPagamentos: [],
        meioPagamentoDefaul: [],
        totalAberto: 0,
        totalPago: 0,
        item_pagos: [],
        valor_pago: 0,
        cep: endereco.cep,
        logradouro: endereco.logradouro,
        numero: endereco.numero,
        complemento: endereco.complemento,
        uf: endereco.uf,
        cidade: endereco.cidade,
        bairro: endereco.bairro,
        fone: endereco.fone,
        funcionario: header[0].funcionario,
        funcionarioDefault: atendenteDefault,
        acrescimo: header[0].acrescimo,
        desconto: header[0].desconto,
        total: header[0].total,
        item_precificao: "",
        item_recurso: "",
        item_quantidade: "",
        item_unitario: "",
        item_total: "",
        total_quantidade: quantidade,
        total_desconto: desconto,
        total_acrescimo: acrescimo,
        total_geral: total + header[0].taxa,
        observacao: header[0].observacao,
        eNovoOuEdicao: true,
      });
    } catch (error) {}
  };

  salvar = async () => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");
    const pessoa = sessionStorage.getItem("pessoaid");
    const grupo = sessionStorage.getItem("grupo");

    const data = {
      numero: this.state.os,
      nivel: 1,
      status: this.state.status,
      emissao: this.state.emissao,
      emissaoh: this.state.emissaoh,
      entrega: this.state.entrega,
      taxa: this.state.taxa,
      funcionario: this.state.funcionario,
      aprovacao: null,
      aprovacaoh: "",
      aprovador: null,
      conclusao: null,
      conclusaoh: "",
      concluidor: null,
      meiopagamento: null,
      meioPagamento: "",
      meioPagamentos: [],
      meioPagamentoDefaul: [],
      totalAberto: 0,
      totalPago: 0,
      item_pagos: [],
      valor_pago: 0,
      cliente: this.state.cliente,
      acrescimo: this.state.total_acrescimo,
      desconto: this.state.total_desconto,
      total: Number(this.state.total_geral) + Number(this.state.taxa),
      observacao: this.state.observacao,
      items: this.state.itens_carrinho,
    };

    let isCombo  = false
    let pedidoLiberado = true
    let itensCombos = [];
    const combo = new Object()
    this.state.itens_carrinho.forEach(element => {
      if(element.combo && !combo[ element.combo ]) {
        combo[ element.combo ] = element.combo
        isCombo = true
        itensCombos.push(element.combo)
      }

      
    });

    if(itensCombos.length > 1 ) {
      pedidoLiberado = false
      this.Loading(false);
      return toast.error("O pedido já possui combo e não pode se misturar com pedido sem combo.");

    }

    const permissoes = await api
      .get(`/api/permissao/${grupo}`, {
        headers: {
          "x-access-token": token,
        },
      })
      .catch((e) => {
        this.Loading(false);
        toast.error("Problemas ao listar as pessoas.");
      });

    const empresaVendas = permissoes.data.filter(function (value) {
      return value.idmenu == 4;
    });

    if (
      empresaVendas.length > 0 &&
      empresaVendas[0].permissao.indexOf("INSERIR") < 0
    )
      return toast.error("O usuário sem permissão.");

      if(pedidoLiberado ) {

        await api
            .post("/api/vendas", data, {
              headers: {
                "x-access-token": token,
              },
            })
            .then(async (data) => {
              toast.success("Serviço Finalizdo com Sucesso!");
      
              await api
                .get("/api/vendas", {
                  headers: {
                    "x-access-token": token,
                  },
                })
                .then(async (response) => {
                  //window.location.href = "/venda";
      
                  const dados = response.data.sort(function(a,b){
                    // Turn your strings into dates, and then subtract them
                    // to get a value that is either negative, positive, or zero.
                    return new Date(b.emissao) - new Date(a.emissao);
                  });
      
                  this.Loading(false);
                  this.setState({
                    id: "",
                    os: "",
                    status: "",
                    listaStatus: "",
                    statusDefault: [],
                    emissao: "",
                    emissaoh: "",
                    clientes: [],
                    clienteDefault: [],
                    funcionario: null,
                    funcionarios: [],
                    funcionarioDefault: [],
                    servicos: [],
                    itens_carrinho: [],
                    item_grupo: "",
                    item_tipo: "",
                    item_recurso: "",
                    item_quantidade: "",
                    item_unitario: "",
                    item_total: "",
                    total_quantidade: 0,
                    total_desconto: 0,
                    total_acrescimo: 0,
                    total_geral: 0,
                    meioPagamento: "",
                    meioPagamentos: [],
                    meioPagamentoDefaul: [],
                    totalAberto: 0,
                    totalPago: 0,
                    item_pagos: [],
                    valor_pago: 0,
                    cep: "",
                    logradouro: "",
                    numero: "",
                    complemento: "",
                    uf: "",
                    cidade: "",
                    bairro: "",
                    fone: "",
                    observacao: "",
                    items: dados,
                    eNovoOuEdicao: false,
                  });
                })
                .catch((e) => {
                  this.Loading(false);
                  toast.error("Ops! Error:" + e);
                });
            })
            .catch((error) => {
              this.Loading(false);
              toast.error("Ocorreu um erro ao tentar salvar o serviço.");
            });
        };
  }

  cancelar = async () => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");
    const pessoa = sessionStorage.getItem("pessoaid");
    const grupo = sessionStorage.getItem("grupo");

    const permissoes = await api
      .get(`/api/permissao/${grupo}`, {
        headers: {
          "x-access-token": token,
        },
      })
      .catch((e) => {
        this.Loading(false);
        toast.error("Problemas ao listar as pessoas.");
      });

    const empresaVendas = permissoes.data.filter(function (value) {
      return value.idmenu == 4;
    });
    if (
      empresaVendas.length > 0 &&
      empresaVendas[0].permissao.indexOf("EXCLUIR") < 0
    )
      return toast.error("O usuário sem permissão.");

    toast.warn("Serviço Cancelado com Sucesso!");

    await api
      .get("/api/vendas", {
        headers: {
          "x-access-token": token,
        },
      })
      .then(async (response) => {
        this.Loading(false);
        //window.location.href = "/venda";
        const dados = response.data.sort(function(a,b){
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.emissao) - new Date(a.emissao);
        });
        this.setState({
          id: "",
          os: "",
          status: "",
          listaStatus: "",
          statusDefault: [],
          emissao: "",
          emissaoh: "",
          clientes: [],
          clienteDefault: [],
          funcionario: null,
          funcionarios: [],
          funcionarioDefault: [],
          servicos: [],
          itens_carrinho: [],
          item_recurso: "",
          item_quantidade: "",
          item_unitario: "",
          item_total: "",
          total_quantidade: 0,
          total_desconto: 0,
          total_acrescimo: 0,
          total_geral: 0,
          meioPagamento: "",
          meioPagamentos: [],
          meioPagamentoDefaul: [],
          totalAberto: 0,
          totalPago: 0,
          item_pagos: [],
          valor_pago: 0,
          cep: "",
          logradouro: "",
          numero: "",
          complemento: "",
          uf: "",
          cidade: "",
          bairro: "",
          fone: "",
          observacao: "",
          items: dados,
          eNovoOuEdicao: false,
        });
      })
      .catch((e) => {
        this.Loading(false);
        toast.error("Ops! Error:" + e);
      });
  };

  aprovacao = async (id) => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");
    const pessoa = sessionStorage.getItem("pessoaid");
    const grupo = sessionStorage.getItem("grupo");

    let hoje = new Date();
    var data = {
      aprovacao: moment(hoje).format("YYYY-MM-DD"),
      aprovacaoh: moment(hoje).format("HH:mm"),
      aprovador: pessoa,
    };

    const permissoes = await api
      .get(`/api/permissao/${grupo}`, {
        headers: {
          "x-access-token": token,
        },
      })
      .catch((e) => {
        this.Loading(false);
        toast.error("Problemas ao listar as pessoas.");
      });

    const empresaVendas = permissoes.data.filter(function (value) {
      return value.idmenu == 4;
    });
    if (
      empresaVendas.length > 0 &&
      empresaVendas[0].permissao.indexOf("ALTERAR") < 0
    )
      return toast.error("O usuário sem permissão.");

    
    await api
      .patch(`/api/vendas/aprovacao/${id}`, data, {
        headers: {
          "x-access-token": token,
        },
      })
      .then(async (data) => {
        this.Loading(false);
        
        if(data.data.success) {
          toast.warning("Aprovação Realizada!");

          await api
            .get("/api/vendas", {
              headers: {
                "x-access-token": token,
              },
            })
            .then(async (response) => {
              this.Loading(false);
              const dados = response.data.sort(function(a,b){
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                return new Date(b.emissao) - new Date(a.emissao);
              });
              this.setState({
                id: "",
                os: "",
                status: "",
                listaStatus: "",
                statusDefault: [],
                emissao: "",
                emissaoh: "",
                clientes: [],
                clienteDefault: [],
                funcionario: null,
                funcionarios: [],
                funcionarioDefault: [],
                servicos: [],
                itens_carrinho: [],
                item_recurso: "",
                item_quantidade: "",
                item_unitario: "",
                item_total: "",
                total_quantidade: 0,
                total_desconto: 0,
                total_acrescimo: 0,
                total_geral: 0,
                meioPagamento: "",
                meioPagamentos: [],
                meioPagamentoDefaul: [],
                totalAberto: 0,
                totalPago: 0,
                item_pagos: [],
                valor_pago: 0,
                cep: "",
                logradouro: "",
                numero: "",
                complemento: "",
                uf: "",
                cidade: "",
                bairro: "",
                fone: "",
                observacao: "",
                items: dados,
                eNovoOuEdicao: false,
              });
            })
            .catch((e) => {
              toast.error("Ops! Error:" + e);
            });
        } else {
          toast.error(`Ops! Cancele a operação: ${data.data.error}`);
        }
      })
      .catch((error) => {
        this.Loading(false);
        toast.error("Ocorreu um erro ao tentar salvar o serviço.");
      });
  };

  cancelar = async (id) => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");
    const pessoa = sessionStorage.getItem("pessoaid");
    const grupo = sessionStorage.getItem("grupo");

    let hoje = new Date();
    var data = {
      cancelar: moment(hoje).format("YYYY-MM-DD"),
      cancelarh: moment(hoje).format("HH:mm"),
      cancelador: pessoa,
    };

    const permissoes = await api
      .get(`/api/permissao/${grupo}`, {
        headers: {
          "x-access-token": token,
        },
      })
      .catch((e) => {
        this.Loading(false);
        toast.error("Problemas ao listar as pessoas.");
      });

    const empresaVendas = permissoes.data.filter(function (value) {
      return value.idmenu == 4;
    });
    if (
      empresaVendas.length > 0 &&
      empresaVendas[0].permissao.indexOf("ALTERAR") < 0
    )
      return toast.error("O usuário sem permissão.");

    await api
      .patch(`/api/vendas/cancelar/${id}`, data, {
        headers: {
          "x-access-token": token,
        },
      })
      .then(async (data) => {
        this.Loading(false);
        toast.success("Serviço Finalizdo com Sucesso!");

        await api
          .get("/api/vendas", {
            headers: {
              "x-access-token": token,
            },
          })
          .then(async (response) => {
            this.Loading(false);
            const dados = response.data.sort(function(a,b){
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              return new Date(b.emissao) - new Date(a.emissao);
            });

            this.setState({
              id: "",
              os: "",
              status: "",
              listaStatus: "",
              statusDefault: [],
              emissao: "",
              emissaoh: "",
              clientes: [],
              clienteDefault: [],
              funcionario: null,
              funcionarios: [],
              funcionarioDefault: [],
              servicos: [],
              itens_carrinho: [],
              item_recurso: "",
              item_quantidade: "",
              item_unitario: "",
              item_total: "",
              total_quantidade: 0,
              total_desconto: 0,
              total_acrescimo: 0,
              total_geral: 0,
              meioPagamento: "",
              meioPagamentos: [],
              meioPagamentoDefaul: [],
              totalAberto: 0,
              totalPago: 0,
              item_pagos: [],
              valor_pago: 0,
              cep: "",
              logradouro: "",
              numero: "",
              complemento: "",
              uf: "",
              cidade: "",
              bairro: "",
              fone: "",
              observacao: "",
              items: dados,
              eNovoOuEdicao: false,
            });
          })
          .catch((e) => {
            this.Loading(false);
            toast.error("Ops! Error:" + e);
          });
      })
      .catch((error) => {
        this.Loading(false);
        toast.error("Ocorreu um erro ao tentar salvar o serviço.");
      });
  };

  producao = async (id) => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");
    const pessoa = sessionStorage.getItem("pessoaid");
    const grupo = sessionStorage.getItem("grupo");

    const permissoes = await api
      .get(`/api/permissao/${grupo}`, {
        headers: {
          "x-access-token": token,
        },
      })
      .catch((e) => {
        this.Loading(false);
        toast.error("Problemas ao listar as pessoas.");
      });

    const empresaVendas = permissoes.data.filter(function (value) {
      return value.idmenu == 4;
    });
    if (
      empresaVendas.length > 0 &&
      empresaVendas[0].permissao.indexOf("ALTERAR") < 0
    )
      return toast.error("O usuário sem permissão.");

    await api
      .patch(`/api/vendas/producao/${id}`, null, {
        headers: {
          "x-access-token": token,
        },
      })
      .then(async (data) => {
        this.Loading(false);
        toast.info("Serviço em Produção!");

        await api
          .get("/api/vendas", {
            headers: {
              "x-access-token": token,
            },
          })
          .then(async (response) => {
            this.Loading(false);
            const dados = response.data.sort(function(a,b){
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              return new Date(b.emissao) - new Date(a.emissao);
            });
            ;
            this.setState({
              id: "",
              os: "",
              status: "",
              listaStatus: "",
              statusDefault: [],
              emissao: "",
              emissaoh: "",
              clientes: [],
              clienteDefault: [],
              funcionario: null,
              funcionarios: [],
              funcionarioDefault: [],
              servicos: [],
              itens_carrinho: [],
              item_recurso: "",
              item_quantidade: "",
              item_unitario: "",
              item_total: "",
              total_quantidade: 0,
              total_desconto: 0,
              total_acrescimo: 0,
              total_geral: 0,
              meioPagamento: "",
              meioPagamentos: [],
              meioPagamentoDefaul: [],
              totalAberto: 0,
              totalPago: 0,
              item_pagos: [],
              valor_pago: 0,
              cep: "",
              logradouro: "",
              numero: "",
              complemento: "",
              uf: "",
              cidade: "",
              bairro: "",
              fone: "",
              observacao: "",
              items: dados,
              eNovoOuEdicao: false,
            });
          })
          .catch((e) => {
            this.Loading(false);
            toast.error("Ops! Error:" + e);
          });
      })
      .catch((error) => {
        this.Loading(false);
        toast.error("Ocorreu um erro ao tentar salvar o serviço.");
      });
  };

  produzido = async (id) => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");
    const pessoa = sessionStorage.getItem("pessoaid");
    const grupo = sessionStorage.getItem("grupo");

    const permissoes = await api
      .get(`/api/permissao/${grupo}`, {
        headers: {
          "x-access-token": token,
        },
      })
      .catch((e) => {
        this.Loading(false);
        toast.error("Problemas ao listar as pessoas.");
      });

      let hoje = new Date();
      var pronto = {
        pronto: moment(hoje).format("YYYY-MM-DD"),
        prontoh: moment(hoje).format("HH:mm"),
      };

    const empresaVendas = permissoes.data.filter(function (value) {
      return value.idmenu == 4;
    });
    if (
      empresaVendas.length > 0 &&
      empresaVendas[0].permissao.indexOf("ALTERAR") < 0
    )
      return toast.error("O usuário sem permissão.");

    await api
      .patch(`/api/vendas/produzido/${id}`, pronto, {
        headers: {
          "x-access-token": token,
        },
      })
      .then(async (data) => {
        this.Loading(false);
        toast.info("Produção Finalizada!");
        if (this.state.pedido.meiopagamento) {
          let hoje = new Date();
          var finalizacao = {
            conclusao: moment(hoje).format("YYYY-MM-DD"),
            conclusaoh: moment(hoje).format("HH:mm"),
            concluidor: pessoa,
          };
          await api.patch(`/api/vendas/prepago/${id}`, null, {
            headers: {
              "x-access-token": token,
            },
          });
        }
        await api
          .get("/api/vendas", {
            headers: {
              "x-access-token": token,
            },
          })
          .then(async (response) => {
            this.Loading(false);

            const dados = response.data.sort(function(a,b){
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              return new Date(b.emissao) - new Date(a.emissao);
            });

            this.setState({
              id: "",
              os: "",
              status: "",
              listaStatus: "",
              statusDefault: [],
              emissao: "",
              emissaoh: "",
              clientes: [],
              clienteDefault: [],
              funcionario: null,
              funcionarios: [],
              funcionarioDefault: [],
              servicos: [],
              itens_carrinho: [],
              item_recurso: "",
              item_quantidade: "",
              item_unitario: "",
              item_total: "",
              total_quantidade: 0,
              total_desconto: 0,
              total_acrescimo: 0,
              total_geral: 0,
              meioPagamento: "",
              meioPagamentos: [],
              meioPagamentoDefaul: [],
              totalAberto: 0,
              totalPago: 0,
              item_pagos: [],
              valor_pago: 0,
              cep: "",
              logradouro: "",
              numero: "",
              complemento: "",
              uf: "",
              cidade: "",
              bairro: "",
              fone: "",
              observacao: "",
              items: dados,
              eNovoOuEdicao: false,
            });
          })
          .catch((e) => {
            this.Loading(false);
            toast.error("Ops! Error:" + e);
          });
      })
      .catch((error) => {
        this.Loading(false);
        toast.error("Ocorreu um erro ao tentar salvar o serviço.");
      });
  };

  concluir = async (id) => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");
    const pessoa = sessionStorage.getItem("pessoaid");
    const grupo = sessionStorage.getItem("grupo");

    let hoje = new Date();
    var finalizacao = {
      conclusao: moment(hoje).format("YYYY-MM-DD"),
      conclusaoh: moment(hoje).format("HH:mm"),
      concluidor: pessoa,
    };

    const permissoes = await api
      .get(`/api/permissao/${grupo}`, {
        headers: {
          "x-access-token": token,
        },
      })
      .catch((e) => {
        this.Loading(false);
        toast.error("Problemas ao listar as pessoas.");
      });

    const empresaVendas = permissoes.data.filter(function (value) {
      return value.idmenu == 4;
    });
    if (
      empresaVendas.length > 0 &&
      empresaVendas[0].permissao.indexOf("ALTERAR") < 0
    )
      return toast.error("O usuário sem permissão.");

    await api.patch(`/api/vendas/concluir/${id}`, finalizacao, {
        headers: {
          "x-access-token": token,
        },
      })
      .then(async (data) => {
        this.Loading(false);
        toast.success("Serviço Finalizdo com Sucesso!");

        await api
          .get("/api/vendas", {
            headers: {
              "x-access-token": token,
            },
          })
          .then(async (response) => {
            this.Loading(false);
            const dados = response.data.sort(function(a,b){
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              return new Date(b.emissao) - new Date(a.emissao);
            });

            this.setState({
              id: "",
              os: "",
              status: "",
              listaStatus: "",
              statusDefault: [],
              emissao: "",
              emissaoh: "",
              clientes: [],
              clienteDefault: [],
              funcionario: null,
              funcionarios: [],
              funcionarioDefault: [],
              servicos: [],
              itens_carrinho: [],
              item_recurso: "",
              item_quantidade: "",
              item_unitario: "",
              item_total: "",
              total_quantidade: 0,
              total_desconto: 0,
              total_acrescimo: 0,
              total_geral: 0,
              meioPagamento: "",
              meioPagamentos: [],
              meioPagamentoDefaul: [],
              totalAberto: 0,
              totalPago: 0,
              item_pagos: [],
              valor_pago: 0,
              cep: "",
              logradouro: "",
              numero: "",
              complemento: "",
              uf: "",
              cidade: "",
              bairro: "",
              fone: "",
              observacao: "",
              items: dados,
              eNovoOuEdicao: false,
            });
          })
          .catch((e) => {
            this.Loading(false);
            toast.error("Ops! Error:" + e);
          });
      })
      .catch((error) => {
        this.Loading(false);
        toast.error("Ocorreu um erro ao tentar salvar o serviço.");
      });
  };

  priorizar = async (id) => {
    try {
      this.Loading(true);
      const token = sessionStorage.getItem("token");
      const pessoa = sessionStorage.getItem("pessoaid");
      const grupo = sessionStorage.getItem("grupo");

      const permissoes = await api
        .get(`/api/permissao/${grupo}`, {
          headers: {
            "x-access-token": token,
          },
        })
        .catch((e) => {
          this.Loading(false);
          toast.error("Problemas ao listar as pessoas.");
        });

      const empresaVendas = permissoes.data.filter(function (value) {
        return value.idmenu == 4;
      });
      if (
        empresaVendas.length > 0 &&
        empresaVendas[0].permissao.indexOf("ALTERAR") < 0
      )
        return toast.error("O usuário sem permissão.");

      const vendas = await api
        .get(`/api/vendas/${id}`, {
          headers: {
            "x-access-token": token,
          },
        })
        .catch((err) => {
          this.Loading(false);
          toast.error("Error:" + err);
        });
      this.Loading(false);
      const header = vendas.data[0];

      this.setState({
        id: header[0].id,
        os: header[0].numero,
        nivel: header[0].nivel,
        status: header[0].status,
      });
    } catch (e) {
      this.Loading(false);
      toast.error("Ops! Error:" + e);
    }
  };

  nivel = async (id, status) => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");
    const pessoa = sessionStorage.getItem("pessoaid");
    const grupo = sessionStorage.getItem("grupo");

    const permissoes = await api
      .get(`/api/permissao/${grupo}`, {
        headers: {
          "x-access-token": token,
        },
      })
      .catch((e) => {
        this.Loading(false);
        toast.error("Problemas ao listar as pessoas.");
      });

    const empresaVendas = permissoes.data.filter(function (value) {
      return value.idmenu == 4;
    });
    if (
      empresaVendas.length > 0 &&
      empresaVendas[0].permissao.indexOf("ALTERAR") < 0
    )
      return toast.error("O usuário sem permissão.");

    const data = {
      nivel: status,
    };

    await api
      .patch(`/api/vendas/nivel/${id}`, data, {
        headers: {
          "x-access-token": token,
        },
      })
      .then(async (data) => {
        this.Loading(false);
        await api
          .get("/api/vendas", {
            headers: {
              "x-access-token": token,
            },
          })
          .then((response) => {
            this.Loading(false);
            this.setState({ items: response.data, filtros: response.data });
          })
          .catch((e) => {
            this.Loading(false);
            toast.error("Ops! Error:" + e);
          });
      })
      .catch((error) => {
        this.Loading(false);
        toast.error("Ocorreu um erro ao tentar salvar o serviço.");
      });
  };

  adicionar = async () => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");
        
    var novoCarrinho = this.state.itens_carrinho ? this.state.itens_carrinho : [];

    const tipoItem        = this.state.item_tipo
    const recursoItem     = this.state.item_recurso
    const quantidadeItem  = this.state.item_quantidade
    const precoItem       = this.state.item_unitario
    const taxa            = this.state.taxa

    if(!recursoItem) {
      this.Loading(false);
      return toast.error("Ops! Ocorreu um erro inesperado.");
    }

    if(!precoItem) {
      this.Loading(false);
      return toast.error("Ops! Item não possui preço.");
    }

    if(!tipoItem) {
      this.Loading(false);
      return toast.error("Ops! Informe o tipo novamente.");
    }

    const { data } = await api.get(`/api/precificacao/item/${recursoItem}`, {
      headers: {
        "x-access-token": token,
      },
    }).catch((error) => {
      this.Loading(false);
      return toast.error("Ops! Ocorreu um erro inesperado.");
    });

    const promocao = await api.get('/api/promocao', {
      headers: {
          'x-access-token':token,
      }
    });    

    const price = await data.filter(function (value) {
      return value.tipo == tipoItem; 
    });

    if(!price.length) {
      this.Loading(false);
      return toast.error("Ops! Não encontramos preço para o item seleciondo.");
    }

    const item = {
      item:novoCarrinho.length > 0 ? novoCarrinho.length : 1,
      precificacao:price[0].id,
      grupo:price[0].grupo,
      nmgrupo:price[0].nmgrupo,
      nome: price[0].nmservico,
      servico: recursoItem,
      quantidade: quantidadeItem,
      combo: 0,
      tipo: tipoItem,
      desconto:0,
      acrescimo:0,
      preco: precoItem,
      total: quantidadeItem * precoItem
    }

    novoCarrinho.push(item);

    console.log(novoCarrinho)
    const promocaoGroup = new Object();
    const pecasMistas = new Object();
    
    for (let index = 0; index < novoCarrinho.length; index++) {
      const item = novoCarrinho[index];
      if(!promocaoGroup[item.grupo + '_' + item.tipo]) {
        promocaoGroup[item.grupo + '_' + item.tipo] = 0;        
      }
      
      const itensDePromocaoMista = promocao.data.filter(function (value) {
        return value.tipo == item.tipo && value.idgrupo == item.grupo 
      });

      promocaoGroup[item.grupo + '_' + item.tipo] = Number(promocaoGroup[item.grupo + '_' + item.tipo]) + Number(item.quantidade);
      
      if(itensDePromocaoMista.length) {
        if(!pecasMistas[ item.tipo ]) {
          pecasMistas[ item.tipo ] = 0;
        }
        pecasMistas[ item.tipo ] =  Number(pecasMistas[ item.tipo ]) + Number(promocaoGroup[item.grupo + '_' + item.tipo]); 
      }
    }
    
    novoCarrinho.forEach(item => {
        
      const precoPromocao = promocao.data.filter(function (value) {
        return value.tipo == item.tipo && value.idgrupo == item.grupo &&
          ( Number(promocaoGroup[item.grupo + '_' + item.tipo]) >= Number(value.inicial) &&
            Number(promocaoGroup[item.grupo + '_' + item.tipo]) < Number(value.final))
      });

      const precoPromocaoQualquerPeca = promocao.data.filter(function (value) {
        return value.tipo == item.tipo && value.idgrupo == null &&
          ( pecasMistas[item.tipo] >= Number(value.inicial) &&
          pecasMistas[item.tipo] < Number(value.final))
      });

      const itensDePromocaoMista = promocao.data.filter(function (value) {
        return value.tipo == item.tipo && value.idgrupo == item.grupo 
      });

      if(precoPromocao.length) {
        item.desconto  = item.preco > precoPromocao[0].preco ? ( item.quantidade * ( item.preco - precoPromocao[0].preco ) ) : 0
        item.acrescimo = item.preco < precoPromocao[0].preco ? ( item.quantidade * ( precoPromocao[0].preco - item.preco) ) : 0
        item.preco =  item.preco
        item.total = item.acrescimo + ( item.quantidade * item.preco ) -  item.desconto
      } else if(precoPromocaoQualquerPeca.length && itensDePromocaoMista.length) {
        item.desconto  = 0
        item.acrescimo = 0
        item.preco =  item.preco
        item.total = item.acrescimo + ( item.quantidade * item.preco ) -  item.desconto
      }

    
    });

    var total_quantidade = novoCarrinho.reduce(function (total, currentValue) {
      return Number(total) + Number(currentValue.quantidade);
    }, 0);

    var total_desconto = novoCarrinho.reduce(function (total, currentValue) {
      return Number(total) + Number(currentValue.desconto);
    }, 0);

    var total_acrescimo = novoCarrinho.reduce(function (total, currentValue) {
      return Number(total) + Number(currentValue.acrescimo)  + Number(taxa);
    }, 0);

    var total_geral = novoCarrinho.reduce(function (total, currentValue) {
      return Number(total) + Number(currentValue.total) + Number(taxa);
    }, 0);
     

    this.Loading(false);
    this.setState({
      itens_carrinho: novoCarrinho,
      item_recurso: "",
      item_quantidade: "",
      item_unitario: "",
      item_total: "",
      total_quantidade: total_quantidade,
      total_desconto:total_desconto,
      total_acrescimo: total_acrescimo,
      total_geral: total_geral,
      tiposDefault: [tipos[0]],
      meioPagamento: "",
      meioPagamentos: [],
      meioPagamentoDefaul: [],
      servicoDefault: [],
      totalAberto: 0,
      totalPago: 0,
      item_pagos: [],
      valor_pago: 0,
    });  
  };

  carregaCombo = async () => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");
   
    var novoCarrinho      = this.state.itens_carrinho ? this.state.itens_carrinho : [];
    const cliente         = this.state.cliente
    const taxa            = this.state.taxa

    
    const { data } = await api.get('/api/antecipada', {
        headers: {
            'x-access-token':token,
        }
    });

    const itemsCarrinho = []
    await novoCarrinho.forEach(async carrinho => {

      const getDataCombo = await data.filter(function (value) {
        return value.idcliente == cliente && value.tipo == carrinho.tipo && value.idgrupo == carrinho.grupo; 
      });

      if(getDataCombo.length > 0 ) {
        carrinho.desconto  = carrinho.preco > getDataCombo[0].unitario ? ( carrinho.quantidade * ( carrinho.preco - getDataCombo[0].unitario ) ) : 0
        carrinho.acrescimo = carrinho.preco < getDataCombo[0].unitario ? ( carrinho.quantidade * ( getDataCombo[0].unitario - carrinho.preco) ) : 0
        carrinho.preco =  carrinho.preco
        carrinho.total = carrinho.acrescimo + ( carrinho.quantidade * carrinho.preco ) -  carrinho.desconto
        carrinho.combo =  getDataCombo[0].id
      } 
      
      itemsCarrinho.push(carrinho)
    });

    var total_quantidade = novoCarrinho.reduce(function (total, currentValue) {
      return Number(total) + Number(currentValue.quantidade);
    }, 0);

    var total_desconto = novoCarrinho.reduce(function (total, currentValue) {
      return Number(total) + Number(currentValue.desconto);
    }, 0);

    var total_acrescimo = novoCarrinho.reduce(function (total, currentValue) {
      return Number(total) + Number(currentValue.acrescimo) + Number(taxa);
    }, 0);

    var total_geral = novoCarrinho.reduce(function (total, currentValue) {
      return Number(total) + Number(currentValue.total) + Number(taxa);
    }, 0);
    
    this.Loading(false);
    this.setState({
      itens_carrinho: itemsCarrinho,
      item_recurso: "",
      item_quantidade: "",
      item_unitario: "",
      item_total: "",
      total_quantidade: total_quantidade,
      total_desconto:total_desconto,
      total_acrescimo: total_acrescimo,
      total_geral: Number(total_geral) + Number(this.state.taxa),
      tiposDefault: [tipos[0]],
      meioPagamento: "",
      meioPagamentos: [],
      meioPagamentoDefaul: [],
      servicoDefault: [],
      totalAberto: 0,
      totalPago: 0,
      item_pagos: [],
      valor_pago: 0,
    });  

  };

  excluir = async (row) => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");
        
    var novoCarrinho = this.state.itens_carrinho ? this.state.itens_carrinho : [];
    const carrinhoExcluido = []
    await novoCarrinho.forEach(carrinho => {
      if(carrinho != row) {
        carrinhoExcluido.push(carrinho)
      }       
    });

    const preco = await api.get(`/api/precificacao`, {
      headers: {
        "x-access-token": token,
      },
    })
   
    const promocao = await api.get('/api/promocao', {
      headers: {
          'x-access-token':token,
      }
    })

    const promocaoGroup = new Object()
    for (let index = 0; index < carrinhoExcluido.length; index++) {
      const item = carrinhoExcluido[index];
      if(!promocaoGroup[item.grupo + '_' + item.tipo]) {
        promocaoGroup[item.grupo + '_' + item.tipo] = 0;        
      }
      promocaoGroup[item.grupo + '_' + item.tipo] = Number(promocaoGroup[item.grupo + '_' + item.tipo]) + Number(item.quantidade);
    }

  
    carrinhoExcluido.forEach(item => {
      
      const precoPromocao = promocao.data.filter(function (value) {
        return value.tipo == item.tipo && value.idgrupo == item.grupo &&
          ( Number(promocaoGroup[item.grupo + '_' + item.tipo]) >= Number(value.inicial) &&
            Number(promocaoGroup[item.grupo + '_' + item.tipo]) < Number(value.final))
      });
      console.log(preco)
      const priceFind = preco.data.filter(function (value) {
        return value.tipo == item.tipo && value.idservico == item.servico
      });


      if(precoPromocao.length) {
        item.desconto  = item.preco > precoPromocao[0].preco ? ( item.quantidade * ( item.preco - precoPromocao[0].preco ) ) : 0
        item.acrescimo = item.preco < precoPromocao[0].preco ? ( item.quantidade * ( precoPromocao[0].preco - item.preco) ) : 0
        item.preco =  precoPromocao[0].preco
        item.total = item.quantidade * item.preco
 
      } else if(priceFind.length) {
        item.desconto  = 0
        item.acrescimo = 0
        item.preco =  priceFind[0].preco
        item.total = item.quantidade * item.preco

      }
    });

    var total_quantidade = carrinhoExcluido.reduce(function (total, currentValue) {
      return Number(total) + Number(currentValue.quantidade);
    }, 0);

    var total_desconto = carrinhoExcluido.reduce(function (total, currentValue) {
      return Number(total) + Number(currentValue.desconto);
    }, 0);

    var total_acrescimo = carrinhoExcluido.reduce(function (total, currentValue) {
      return Number(total) + Number(currentValue.acrescimo);
    }, 0);

    var total_geral = carrinhoExcluido.reduce(function (total, currentValue) {
      return Number(total) + Number(currentValue.total);
    }, 0);

   

    this.Loading(false);
    this.setState({
      itens_carrinho: carrinhoExcluido,
      item_recurso: "",
      item_quantidade: "",
      item_unitario: "",
      item_total: "",
      total_quantidade: total_quantidade,
      total_desconto:total_desconto,
      total_acrescimo: total_acrescimo,
      total_geral: total_geral,
      meioPagamento: "",
      meioPagamentos: [],
      meioPagamentoDefaul: [],
      servicoDefault: [],
      totalAberto: 0,
      totalPago: 0,
      item_pagos: [],
      valor_pago: 0,
    });  
    
  };

  lancamentos = async (row) => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");

    await api
      .get("/api/pagamento", {
        headers: {
          "x-access-token": token,
        },
      })
      .then((response) => {
        const meios = [];
        response.data.forEach((element) => {
          meios.push({ value: element.id, label: element.nome });
        });
        this.Loading(false);
        this.setState({
          id: row.id,
          meioPagamentos: meios,
          meioPagamento: "",
          meioPagamentoDefaul: [],
          totalAberto: Number(row.total).toFixed(2),
          totalPago: 0,
          item_pagos: [],
          valor_pago: Number(row.total).toFixed(2),
        });
      })
      .catch((e) => {
        this.Loading(false);
        toast.error("Ocorreu um erro.");
      });
  };

  lancar = async (id, valor) => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");

    const condicao = await api
      .get(`/api/pagamento/${this.state.meioPagamento}`, {
        headers: {
          "x-access-token": token,
        },
      })
      .catch((error) => {
        this.Loading(false);
        toast.error("Ops! Ocorreu um erro inesperado.");
      });

    let valorPago = 0;
    const pagamentos = this.state.item_pagos.length
      ? this.state.item_pagos
      : [];

    if (Number(valorPago) > Number(this.state.totalAberto)) {
      this.Loading(false);
      toast.error("Valor pago maior que o valor à pagar.");
    }

    pagamentos.push({
      id: pagamentos.length + 1,
      pagamento: condicao.data.nome,
      meiopagamento: condicao.data.id,
      valor: valor,
      os: id,
    });

    pagamentos.forEach((element) => {
      valorPago += parseFloat(element.valor);
    });

    await api
      .get("/api/pagamento", {
        headers: {
          "x-access-token": token,
        },
      })
      .then((response) => {
        const meios = [];
        response.data.forEach((element) => {
          meios.push({ value: element.id, label: element.nome });
        });

        let faltaPagar =
          Number(this.state.totalAberto).toFixed(2) -
          Number(valorPago).toFixed(2);
        this.Loading(false);
        this.setState({
          meioPagamentos: meios,
          meioPagamento: "",
          meioPagamentoDefaul: [],
          totalPago: Number(valorPago).toFixed(2),
          item_pagos: pagamentos,
          valor_pago: Number(faltaPagar).toFixed(2),
        });
      });
  };

  pagar = async () => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");
    const pessoa = sessionStorage.getItem("pessoaid");

    let hoje = new Date();
    var finalizacao = {
      conclusao: moment(hoje).format("YYYY-MM-DD"),
      conclusaoh: moment(hoje).format("HH:mm"),
      concluidor: pessoa,
    };
    if (
      !this.state.item_pagos.length ||
      this.state.totalPago != this.state.totalAberto
    ) {
      this.Loading(false);
      return toast.error(
        "Não possui lançamentos suficiente para fechamento do serviço."
      );
    }
    // Antecipação
    if (this.state.pedido && this.state.pedido.status == 2) {
      const condicao =
        this.state.item_pagos.length > 0
          ? this.state.item_pagos[0].meiopagamento
          : 1;
      const antecipacao = {
        condicao: condicao,
      };
      await api
        .patch(`/api/vendas/antecipacao/${this.state.pedido.id}`, antecipacao, {
          headers: {
            "x-access-token": token,
          },
        })
        .then(async (data) => {
          this.Loading(false);
          await this.state.item_pagos.forEach(async (element) => {
            const data = {
              ordemservico: element.os,
              data: moment(hoje).format("YYYY-MM-DD"),
              hora: moment(hoje).format("HH:mm"),
              pagamento: element.meiopagamento,
              valor: element.valor,
            };
            await api
              .post("/api/movimento", data, {
                headers: {
                  "x-access-token": token,
                },
              })
              .catch((error) => {
                this.Loading(false);
                toast.error("Ops! Ocorreu um erro inesperado.");
              });
          });

          await api
            .get("/api/vendas", {
              headers: {
                "x-access-token": token,
              },
            })
            .then(async (response) => {
              this.Loading(false);
              toast.success("Serviço Finalizdo com Sucesso!");
              this.setState({
                id: "",
                os: "",
                status: "",
                listaStatus: "",
                statusDefault: [],
                emissao: "",
                emissaoh: "",
                clientes: [],
                clienteDefault: [],
                funcionario: null,
                funcionarios: [],
                funcionarioDefault: [],
                servicos: [],
                itens_carrinho: [],
                item_grupo: "",
                item_recurso: "",
                item_quantidade: "",
                item_unitario: "",
                item_total: "",
                total_quantidade: 0,
                total_desconto: 0,
                total_acrescimo: 0,
                total_geral: 0,
                meioPagamento: "",
                meioPagamentos: [],
                meioPagamentoDefaul: [],
                totalAberto: 0,
                totalPago: 0,
                item_pagos: [],
                valor_pago: 0,
                cep: "",
                logradouro: "",
                numero: "",
                complemento: "",
                uf: "",
                cidade: "",
                bairro: "",
                fone: "",
                observacao: "",
                items: response.data,
                eNovoOuEdicao: false,
              });
            })
            .catch((e) => {
              this.Loading(false);
              toast.error("Ops! Error:" + e);
            });
        })
        .catch((error) => {
          this.Loading(false);
          toast.error("Ocorreu um erro ao tentar salvar o serviço.");
        });
    } else {
      await api
        .patch(`/api/vendas/concluir/${this.state.id}`, finalizacao, {
          headers: {
            "x-access-token": token,
          },
        })
        .then(async (data) => {
          this.Loading(false);
          await this.state.item_pagos.forEach(async (element) => {
            const data = {
              ordemservico: element.os,
              data: moment(hoje).format("YYYY-MM-DD"),
              hora: moment(hoje).format("HH:mm"),
              pagamento: element.meiopagamento,
              valor: element.valor,
            };
            await api
              .post("/api/movimento", data, {
                headers: {
                  "x-access-token": token,
                },
              })
              .catch((error) => {
                this.Loading(false);
                toast.error("Ops! Ocorreu um erro inesperado.");
              });
          });

          await api
            .get("/api/vendas", {
              headers: {
                "x-access-token": token,
              },
            })
            .then(async (response) => {
              this.Loading(false);
              toast.success("Serviço Finalizdo com Sucesso!");
              this.setState({
                id: "",
                os: "",
                status: "",
                listaStatus: "",
                statusDefault: [],
                emissao: "",
                emissaoh: "",
                clientes: [],
                clienteDefault: [],
                funcionario: null,
                funcionarios: [],
                funcionarioDefault: [],
                servicos: [],
                itens_carrinho: [],
                item_grupo: "",
                item_recurso: "",
                item_quantidade: "",
                item_unitario: "",
                item_total: "",
                total_quantidade: 0,
                total_desconto: 0,
                total_acrescimo: 0,
                total_geral: 0,
                meioPagamento: "",
                meioPagamentos: [],
                meioPagamentoDefaul: [],
                totalAberto: 0,
                totalPago: 0,
                item_pagos: [],
                valor_pago: 0,
                cep: "",
                logradouro: "",
                numero: "",
                complemento: "",
                uf: "",
                cidade: "",
                bairro: "",
                fone: "",
                observacao: "",
                items: response.data,
                eNovoOuEdicao: false,
              });
            })
            .catch((e) => {
              this.Loading(false);
              toast.error("Ops! Error:" + e);
            });
        })
        .catch((error) => {
          this.Loading(false);
          toast.error("Ocorreu um erro ao tentar salvar o serviço.");
        });
    }
  };

  atendimento = async (row) => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");

    const listaMotivos = await api.get("/api/motivo", {
      headers: {
        "x-access-token": token,
      },
    })

    const listaEvento = await api.get(`/api/evento/${row.id}`, {
      headers: {
        "x-access-token": token,
      },
    })

    const motivos = []
  
    listaMotivos.data.forEach((element) => {
      motivos.push({
        value: element.id,
        label: element.nome,
      });
    });

    const vendas = await api.get(`/api/vendas/${row.id}`, {
      headers: {
        "x-access-token": token,
      },
    })
    .catch((err) => {
      this.Loading(false);
      toast.error("Error:" + err);
    });
    const header = vendas.data[0];
    const itens = vendas.data[1];
    
    this.Loading(false);
    this.setState({
      motivos: motivos,
      eventos_atendimento:listaEvento.data,
      cliente_atendimento: header[0].cliente,
      venda_atendimento: row.id
    })       
  };

  salvarAtendimento = async () => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");

    const hoje = new Date();
    
    const data = {
      ordemservico:this.state.venda_atendimento, 
      cliente: this.state.cliente_atendimento, 
      data:moment(hoje).format("YYYY-MM-DD"), 
      hora:  moment(hoje).format("HH:mm"),
      motivo: this.state.motivo_atendimento, 
      observacao: this.state.descricao_atendimento,
    }

    this.Loading(false);
    await api.post("/api/evento", data, {
      headers: {
        "x-access-token": token,
      },
    })
    .catch((error) => {
      this.Loading(false);
      toast.error("Ops! Ocorreu um erro inesperado.");
    });

  }

  opcaoMenu = async (selecao) => {
    this.setState({ pedido: selecao });
  };

  imprimir = async (id) => {
    this.Loading(true);
    const baseUrl = window.location.origin; // Pega o domínio atual (ex.: http://localhost:3000)
    window.open(
      `${baseUrl}/cupom/${id}`,
      "pagina",
      `width=350, height=600, top=100, left=210, scrollbars=yes`
    );
    this.Loading(false);
  };
  

  onChangeRecursoCarrinho = async (e) => {

    const token = sessionStorage.getItem("token");
    
    this.Loading(true);

    this.setState({tiposDefault:  [ { label: "Lavar/Passa", value: "1" } ]})

    const tipoValue = 1

    const listarPreco = await api.get("/api/precificacao", {
      headers: {
        "x-access-token": token,
      },
    }).catch((error) => {
      this.Loading(false);
      toast.error("Ops! Ocorreu um erro inesperado.");
    });

    const listarServico = await api.get("/api/servico", {
        headers: {
        "x-access-token": token,
        },
    }).catch((error) => {
        this.Loading(false);
        toast.error("Ops! Ocorreu um erro inesperado.");
    });

    if (!listarPreco.data.length) {
        this.Loading(false);
        toast.error("Não foi localizado nenhum preço cadastrado.");
    }

    const servicoDefault = [];
    listarServico.data.forEach((element) => {
    if (element.id == e.value)
        servicoDefault.push({
          value: element.id,
          label: element.codigo + " " + element.nome,
        });
    });

    
    const preco = await listarPreco.data.filter(function (el) {
      return el.idservico == e.value && el.tipo == tipoValue;
    });

    //if (!preco.length) return toast.error("O item " + e.label +" encontra-se sem preço");

    
    if (preco.length) {
      var tipoDefault = preco[0].tipo == 1 ? tipos[0] : preco[0].tipo == 2 ? tipos[1] : tipos[2];
      console.log('default', tipoDefault)
      this.Loading(false);
      this.setState({
          listatipos: tipos,
          tiposDefault: [tipoDefault],
          servicoDefault: servicoDefault[0],
          item_tipo: tipos[0].value,
          item_grupo: preco[0].idgrupo,
          item_recurso: preco[0].idservico,
          item_quantidade: 1,
          item_unitario: preco[0].preco.toFixed(2),
          item_total: (preco[0].preco * 1).toFixed(2),
      });
    } else {
      console.log('default', tipoDefault)
      this.setState({
        listatipos: tipos,
        tiposDefault: [tipos[0]],
        servicoDefault: servicoDefault[0],
        item_tipo: '',
        item_grupo: '',
        item_recurso:servicoDefault[0].value,
        item_quantidade: 1,
        item_unitario: 0,
        item_total: 0,
      });

    }
  };

  onChangeTipoRecursoCarrinho = async (e) => {
   
    
    const token = sessionStorage.getItem("token");
    
    const recurso = this.state.item_recurso;
   
    this.setState({tiposDefault:  tipos[e.value - 1]})
    
    this.Loading(true);
   
    const listarPreco = await api.get("/api/precificacao", {
      headers: {
        "x-access-token": token,
      },
    }).then(async res => {
      var preco = await res.data.filter(function (el) {
        return el.idservico == recurso && el.tipo == e.value;
      });

      if (preco.length) {
        this.Loading(false);
        this.setState({
          item_tipo: e.value,
          item_unitario: preco[0].preco.toFixed(2),
          item_total: (preco[0].preco * ( Number(this.state.item_quantidade) || 1)).toFixed(2),
        });
      } else {
        this.Loading(false);
        this.setState({
          item_tipo: null,
          item_unitario: 0,
          item_total: 0,
          tiposDefault:[{ label: "Lavar/Passa", value: "1" }]
        });
  
        toast.error(
          "O preço para o tipo " +
            (e.value == 1 ? "Lavar/Passar" : e.value == 2 ? "Lavar" : "Passar") +
            " não informado."
        );
      }
    })
    .catch((error) => {
      this.Loading(false);
      toast.error("Ops! Ocorreu um erro inesperado.");
    });
  };

  onChangeCliente = async (e) => {
    this.Loading(true);
    const token = sessionStorage.getItem("token");

    const pessoaSelecionada = await api
      .get(`/api/pessoa/${e.value}`, {
        headers: {
          "x-access-token": token,
        },
      })
      .catch((error) => {
        this.Loading(false);
        toast.error("Ops! Ocorreu um erro inesperado.");
      });
    this.Loading(false);
    this.setState({
      cep: pessoaSelecionada.data.cep ? pessoaSelecionada.data.cep : "",
      logradouro: pessoaSelecionada.data.endereco
        ? pessoaSelecionada.data.endereco
        : "",
      numero: pessoaSelecionada.data.numero
        ? pessoaSelecionada.data.numero
        : "",
      complemento: pessoaSelecionada.data.complemento
        ? pessoaSelecionada.data.complemento
        : "",
      uf: pessoaSelecionada.data.uf ? pessoaSelecionada.data.uf : "",
      cidade: pessoaSelecionada.data.cidade
        ? pessoaSelecionada.data.cidade
        : "",
      bairro: pessoaSelecionada.data.bairro
        ? pessoaSelecionada.data.bairro
        : "",
      fone: pessoaSelecionada.data.fone ? pessoaSelecionada.data.fone : "",
      cliente: e.value,
      clienteDefault: [
        {
          label: e.label,
          value: e.value,
        },
      ],
    });
  };

  statusFilter = async (status) => {
    const token = sessionStorage.getItem("token");

    const { items } = this.state;
    this.Loading(true);

    const vendas = await api.get("/api/vendas", {
      headers: {
        "x-access-token": token,
      },
    });

    const novoItems =
      status != 0
        ? vendas.data.filter(function (value) {
            return status != 4 ? value.status == status : value.status == 4 || value.status == 5;
          })
        : vendas.data;

    const dados = novoItems.sort(function(a,b){
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return new Date(b.emissao) - new Date(a.emissao);
    });
    
    this.setState({ items: dados });
    this.Loading(false);
  };

  nivelFilter = async (nivel) => {
    const token = sessionStorage.getItem("token");

    const { items } = this.state;
    this.Loading(true);

    const vendas = await api.get("/api/vendas", {
      headers: {
        "x-access-token": token,
      },
    });

    const novoItems = vendas.data.filter(function (value) {
      return value.nivel == nivel;
    });

    this.setState({ items: novoItems });
    this.Loading(false);
  };

  filtroPronto = async (isFiltroPronto) => {
    this.setState({
      isFiltroPronto: isFiltroPronto? false: true
      
    })
    
  }

  handleFiltroGrid = async (filterText) => {
    const { filtros, items, isFiltroPronto } = this.state;
    this.Loading(true);
   
    const filtragem =
      filterText.length > 0
        ? items.filter((item) => 
            (
              item.cliente +
              "" +
              item.numero +
              "" +
              item.status +
              "" +
              (isFiltroPronto ? dateUtils(item.emissao) : (item.pronto ? dateUtils(item.pronto) : "")) +
              "" +
              item.emissaoh +
              "" +
              item.acrescimo.toFixed(2) +
              "" +
              item.desconto.toFixed(2) +
              "" +
              item.total.toFixed(2) +
              "" 
             /// item.pronto ? dateUtils(item.pronto) : "99/99/9999"
              
            ).toLowerCase().includes(filterText.toLowerCase())
          )
        : filtros;
      //console.log(filtragem) 
    this.setState({ items: filtragem, filterText: filterText, isFiltroPronto: isFiltroPronto });

    this.Loading(false);
  };

  render() {
    const subHeaderComponentMemo = (
      <div class="card-tools">
            <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                <input type="checkbox" class="custom-control-input" id='FILTRAR' checked={ this.state.isFiltroPronto ? "true" : ""} onClick={() => this.filtroPronto(this.state.isFiltroPronto) } />
                <label class="custom-control-label" for='FILTRAR'>{ this.state.isFiltroPronto ? 'Filtrar Por Data Emissão' : 'Filtrar Por Data Pronto'}</label>
            </div> 
          <div class="input-group input-group-sm">
            <input
              type="text"
              class="form-control"
              placeholder="Pesquisar"
              onChange={(e) => this.handleFiltroGrid(e.target.value)}
            />
            <div class="input-group-append">
              <div class="btn btn-primary">
                <i class="fas fa-search"></i>
              </div>
            </div>
          </div>        
      </div>
      
    );

    return (
      <div className="wrapper">
        <div className="content-wrapper">
          <section class="content-header"></section>
          <section class="content">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-2">
                  <button
                    onClick={this.novo}
                    class="btn btn-primary btn-block mb-3"
                  >
                    Nova Venda
                  </button>
                  <button
                    class="btn btn-success btn-block mb-3"
                    data-dismiss="modal"
                    data-toggle="modal"
                    data-target="#modal-cliente"
                    onClick={ this.novoCliente}
                  >
                    Novo Cliente
                  </button>
                  <div class="card">
                    <div class="card-header">
                      <h3 class="card-title">Resumo</h3>
                      <div class="card-tools">
                        <button
                          type="button"
                          class="btn btn-tool"
                          data-card-widget="collapse"
                        >
                          <i class="fas fa-minus"></i>
                        </button>
                      </div>
                    </div>
                    <div class="card-body p-0">
                      <ul class="nav nav-pills flex-column">
                        <li class="nav-item active">
                          <a
                            class="nav-link"
                            href="#"
                            onClick={() => this.statusFilter(0)}
                          >
                            <i class="fas fa-history"></i> Listar Todos
                            <span class="badge bg-info float-right">
                              {this.state.totalizados.todos}{" "}
                            </span>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a
                            class="nav-link"
                            href="#"
                            onClick={() => this.statusFilter(1)}
                          >
                            <i class="fas fa-exclamation"></i> Não Iniciadas
                            <span class="badge bg-danger float-right">
                              {" "}
                              {this.state.totalizados.naoInicia}{" "}
                            </span>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a
                            class="nav-link"
                            href="#"
                            onClick={() => this.statusFilter(2)}
                          >
                            <i class="fas fa-tint"></i> Aprovadas
                            <span class="badge bg-warning float-right">
                              {this.state.totalizados.aprovadas}
                            </span>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a
                            class="nav-link"
                            href="#"
                            onClick={() => this.statusFilter(3)}
                          >
                            <i class="fas fa-clock"></i> Em produção
                            <span class="badge bg-primary float-right">
                              {this.state.totalizados.producao}
                            </span>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a
                            class="nav-link"
                            href="#"
                            onClick={() => this.statusFilter(4)}
                          >
                            <i class="fas fa-check-circle"></i> Pronto
                            <span class="badge bg-green float-right">
                              {this.state.totalizados.pronto}
                            </span>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a
                            class="nav-link"
                            href="#"
                            onClick={() => this.statusFilter(6)}
                          >
                            <i class="fas fa-check-circle"></i> Pagamento
                            <span class="badge bg-green float-right">
                              {this.state.totalizados.pagamento}
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header">
                      <h3 class="card-title">Prioridade</h3>

                      <div class="card-tools">
                        <button
                          type="button"
                          class="btn btn-tool"
                          data-card-widget="collapse"
                        >
                          <i class="fas fa-minus"></i>
                        </button>
                      </div>
                    </div>
                    <div class="card-body p-0">
                      <ul class="nav nav-pills flex-column">
                        <li class="nav-item">
                          <a
                            href="#"
                            class="nav-link"
                            onClick={() => this.nivelFilter(3)}
                          >
                            <i class="fas fa-circle text-danger"></i> ALTA
                          </a>
                        </li>
                        <li class="nav-item">
                          <a
                            href="#"
                            class="nav-link"
                            onClick={() => this.nivelFilter(2)}
                          >
                            <i class="fas fa-circle text-warning"></i> MÉDIA
                          </a>
                        </li>
                        <li class="nav-item">
                          <a
                            href="#"
                            class="nav-link"
                            onClick={() => this.nivelFilter(1)}
                          >
                            <i class="fas fa-circle text-primary"></i> NORMAL
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-md-10">
                  {this.state.eNovoOuEdicao ? (
                    <div class="card card-primary card-outline">
                      <div class="card-header">
                        <h3 class="card-title">Nova Venda</h3>
                      </div>
                      <div class="card-body p-0">
                        <div className="card-body">
                          <div class="row">
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label>Número O.S</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="Número da OS"
                                  value={this.state.os}
                                  readOnly
                                />
                              </div>
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label>Status</label>
                                <Select
                                  id="status"
                                  placeholder="Selecione"
                                  isDisabled="true"
                                  options={this.state.status}
                                  value={this.state.statusDefault}
                                />
                              </div>
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label>Data</label>
                                <input
                                  type="date"
                                  class="form-control"
                                  placeholder="Emissão da OS"
                                  value={this.state.emissao}
                                  readOnly
                                />
                              </div>
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label>Hora</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="Emissão da OS"
                                  value={this.state.emissaoh}
                                  readOnly
                                />
                              </div>
                            </div>
                            

                           
                          </div>

                          <div class="row">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label>Cliente</label>
                                <Select
                                  id="cliente"
                                  placeholder="Selecione"
                                  isDisabled={this.state.id ? true : false}
                                  options={this.state.clientes}
                                  value={this.state.clienteDefault}
                                  onChange={(e) => this.onChangeCliente(e)}
                                />
                              </div>

                              <strong>
                                <i class="fa fa-map-marker margin-r-5"></i>{" "}
                                Endereço
                              </strong>

                              <p class="text-muted">{`${this.state.cep} ${this.state.logradouro} ${this.state.numero} ${this.state.complemento} ${this.state.uf} ${this.state.cidade} ${this.state.bairro}`}</p>

                              <hr />
                            </div>
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label>Atendente</label>
                                <Select
                                  id="atendente"
                                  placeholder="Selecione"
                                  isDisabled="true"
                                  options={this.state.funcionarios}
                                  value={this.state.funcionarioDefault}
                                />
                              </div>

                              <strong>
                                <i class="fa fa-phone margin-r-5"></i> Contato
                              </strong>

                              <p class="text-muted">{`${this.state.fone}`}</p>

                              <hr />
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label>Taxa de Entrega R$</label>
                                <input
                                  type="text"
                                  id="taxa"
                                  name="taxa"
                                  class="form-control"
                                  placeholder="Informe o valor"
                                  value={this.state.taxa}
                                  onChange={(e) =>
                                      this.setState({
                                        taxa: moneyMask(e.target.value),
                                      })
                                  }  
                                />
                                                         
                              </div>
                            </div>
                           
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label>Entrega</label>
                                <input
                                  type="date"
                                  class="form-control"
                                  placeholder="Previsão de Entrega"
                                  value={this.state.entrega}
                                  onChange={(e) =>
                                    this.setState({ entrega: e.target.value })
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label>Observação</label>
                                <textarea
                                  class="form-control"
                                  rows="3"
                                  disabled={
                                    this.state.id && this.state.status != 1
                                      ? true
                                      : false
                                  }
                                  placeholder="Descreva qualquer observação;"
                                  value={this.state.observacao}
                                  onChange={(e) =>
                                    this.setState({
                                      observacao: e.target.value,
                                    })
                                  }
                                ></textarea>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-sm-12">
                              <div class="card card-primary card-outline">
                                <div class="card-header">
                                  <h3 class="card-title"></h3>
                                  <div class="row">
                                    <div class="col-sm-3">
                                      <label>Produto ou Serviço</label>
                                      <Select
                                        id="servico"
                                        placeholder="Selecione"
                                        isSearchable="true"
                                        isOptionSelected
                                        isDisabled={
                                          this.state.cliente &&
                                          !(
                                            this.state.id &&
                                            this.state.status != 1
                                          )
                                            ? false
                                            : true
                                        }
                                        options={this.state.servicos}
                                        value={this.state.servicoDefault}
                                        onChange={(e) =>
                                          this.onChangeRecursoCarrinho(e)
                                        }
                                      />
                                    </div>
                                    <div class="col-sm-2">
                                      <label>Tipo</label>
                                      <Select
                                        id="tipo"
                                        placeholder="Selecione"
                                        isSearchable="true"
                                        isOptionSelected
                                        isDisabled={
                                          this.state.cliente && this.state.item_recurso ? false : true
                                        }
                                        options={this.state.listatipos}
                                        defaultValue={this.state.tiposDefault}
                                        value={this.state.tiposDefault}
                                       
                                        onChange={(e) =>
                                          this.onChangeTipoRecursoCarrinho(e)
                                        }
                                      />
                                    </div>
                                    <div class="col-sm-1">
                                      <div class="form-group">
                                        <label>Quantidade</label>
                                        <input
                                          type="number"
                                          id="item_quantidade"
                                          name="item_quantidade"
                                          class="form-control"
                                          placeholder="Informe a quantidade"
                                          value={this.state.item_quantidade}
                                          onChange={(e) =>
                                            this.setState({
                                              item_quantidade: e.target.value,
                                              item_total: (Number( e.target.value) * Number(this.state.item_unitario)).toFixed(2)
                                            })
                                          }
                                          readOnly={
                                            this.state.item_recurso
                                              ? false
                                              : true
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div class="col-sm-1">
                                      <div className="form-group">
                                        <label>Preço</label>
                                        <input
                                          type="text"
                                          id="item_unitario"
                                          name="item_unitario"
                                          class="form-control"
                                          placeholder="Informe a total"
                                          value={this.state.item_unitario}
                                          onChange={(e) =>
                                            this.setState({
                                              item_unitario: e.value,
                                            })
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </div>
                                    <div class="col-sm-2">
                                      <div class="form-group">
                                        <label>Total</label>
                                        <input
                                          type="number"
                                          id="item_total"
                                          name="item_total"
                                          class="form-control"
                                          placeholder="Informe a total"
                                          value={this.state.item_total}
                                          onChange={(e) =>
                                            this.setState({
                                              item_total: e.value,
                                            })
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </div>
                                    <div class="col-sm-1">
                                      <div class="form-group">
                                        <label>&nbsp;</label>
                                        <button
                                          className={`btn btn-block btn-success ${
                                            this.state.item_recurso
                                              ? ""
                                              : "disabled"
                                          }`}
                                          onClick={ 
                                            this.state.item_recurso
                                              ? this.adicionar
                                              : () => {}
                                          }
                                        >
                                          +
                                        </button>
                                      </div>
                                    </div>
                                    <div class="col-sm-2">
                                      <div class="form-group">
                                        <label>&nbsp;&nbsp;</label>
                                        <button
                                          className={`btn btn-block btn-info ${
                                            this.state.itens_carrinho.length
                                              ? ""
                                              : "disabled"
                                          }`}
                                          onClick={ 
                                            this.state.itens_carrinho.length > 0
                                              ? this.carregaCombo
                                              : () => {}
                                          }
                                        >
                                          Calcular + Combo
                                        </button>
                                      </div>
                                    </div>
                                  </div>                                  
                                </div>
                                
                                <div class="card-body p-0">
                                  
                                  <div class="box-body">
                                    <div class="row">
                                      <div class="col-sm-12">
                                        <DataTable
                                          title="Item Serviço"
                                          columns={[
                                            {
                                              name: "Grupo",
                                              selector: "nmgrupo",
                                              sortable: true,
                                            },
                                            {
                                              name: "Serviço ou Produto",
                                              selector: "nome",
                                              sortable: true,
                                            },
                                            {
                                              name: "Quantidade",
                                              selector: "quantidade",
                                              sortable: true,
                                            },
                                            {
                                              name: "Tipo",
                                              selector: "tipo",
                                              sortable: true,
                                              cell: (row) =>
                                                row.tipo
                                                  ? row.tipo == 1
                                                    ? "Lavar/Passar"
                                                    : row.tipo == 2
                                                    ? "Lavar"
                                                    : "Passar"
                                                  : "",
                                            },
                                            {
                                              name: "Preço",
                                              selector: "preco",
                                              sortable: true,
                                              cell: (row) =>
                                                row.preco
                                                  ? Number(row.preco).toFixed(2)
                                                  : "0.00",
                                            },

                                            {
                                              name: "Desconto",
                                              selector: "desconto",
                                              sortable: true,
                                              cell: (row) =>
                                                row.preco
                                                  ? Number(row.desconto).toFixed(2)
                                                  : "0.00",
                                            },

                                            {
                                              name: "Total",
                                              selector: "total",
                                              sortable: true,
                                              cell: (row) =>
                                                row.total
                                                  ? row.total.toFixed(2)
                                                  : "0.00",
                                            },  

                                            {
                                              name: "é Combo?",
                                              selector: "combo",
                                              sortable: true,
                                              cell: (row) => Number(row.combo) > 0 ?  
                                              <i class="fas fa-toggle-on"></i>
                                              : <i class="fas fa-toggle-off"></i>
                                              
                                              
                                              
                                            },  
                                              
                                                                               
                                            {
                                              name: "Excluir",
                                              selector: "Excluir",
                                              cell: (row) =>
                                                this.state.id &&
                                                this.state.status != 1 ? (
                                                  <div class="btn-group">
                                                    <button
                                                      id="excluir"
                                                      className="btn btn-danger"
                                                      disabled
                                                    >
                                                      <i class="fas fa-trash-alt"></i>
                                                    </button>
                                                  </div>
                                                ) : (
                                                  <div class="btn-group">
                                                    <button
                                                      id="excluir"
                                                      className="btn btn-danger"
                                                      onClick={() =>
                                                        this.state.id &&
                                                        this.state.status != 1
                                                          ? ""
                                                          : this.excluir(row)
                                                      }
                                                    >
                                                      <i class="fas fa-trash-alt"></i>
                                                    </button>
                                                  </div>
                                                ),
                                              button: true,
                                            },
                                          ]}
                                          data={this.state.itens_carrinho}
                                          dense="true"
                                          noHeader="false"
                                          pagination
                                        />
                                        
                                      </div>                                      
                                    </div>                                   
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          

                          <div class="row">
                            <div class="col-md-3 col-sm-6 col-xs-12">
                              <div class="info-box">
                                <span class="info-box-icon bg-aqua">
                                  <i class="ion ion-ios-gear-check"></i>
                                </span>

                                <div class="info-box-content">
                                  <span class="info-box-text">Quantidade</span>
                                  <span class="info-box-number">
                                    {this.state.total_quantidade}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-12">
                              <div class="info-box">
                                <span class="info-box-icon bg-aqua">
                                  <i class="ion ion-ios-gear-check"></i>
                                </span>

                                <div class="info-box-content">
                                  <span class="info-box-text">Desconto</span>
                                  <span class="info-box-number">
                                    {this.state.total_desconto
                                      ? this.state.total_desconto.toFixed(2)
                                      : "0.00"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-12">
                              <div class="info-box">
                                <span class="info-box-icon bg-aqua">
                                  <i class="ion ion-ios-gear-check"></i>
                                </span>

                                <div class="info-box-content">
                                  <span class="info-box-text">Acrescimo</span>
                                  <span class="info-box-number">
                                    {this.state.total_acrescimo
                                      ? this.state.total_acrescimo.toFixed(2)
                                      : "0.00"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-12">
                              <div class="info-box">
                                <span class="info-box-icon bg-aqua">
                                  <i class="ion ion-ios-gear-check"></i>
                                </span>

                                <div class="info-box-content">
                                  <span class="info-box-text">Total</span>
                                  <span class="info-box-number">
                                    {this.state.total_geral
                                      ? this.state.total_geral.toFixed(2)
                                      : "0.00"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card-footer">
                        {this.state.id && this.state.status != 1 ? (
                          <button
                            type="button"
                            class="btn btn-success"
                            disabled
                          >
                            {" "}
                            <i class="far fa-check-circle"></i> Salvar
                          </button>
                        ) : (
                          <button
                            type="submit"
                            class="btn btn-success"
                            onClick={this.salvar}
                          >
                            {" "}
                            <i class="far fa-check-circle"></i> Salvar
                          </button>
                        )}
                        <button
                          type="submit"
                          class="btn btn-danger float-right"
                          onClick={this.cancelar}
                        >
                          {" "}
                          <i class="fas fa-times-circle"></i> Cancelar
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div class="card card-primary card-outline">
                      <div class="card-body p-0">
                        <DataTable
                          title="Listar"
                          columns={[
                            {
                              name: "Número",
                              selector: "numero",
                              sortable: true,
                              cell: (row) => (
                                <a href="#" onClick={() => this.abre(row.id)}>
                                  {row.numero}
                                </a>
                              ),
                            },
                            {
                              name: "Nível",
                              selector: "nivel",
                              sortable: true,
                              cell: (row) =>
                                row.status == 1 ? (
                                  <a
                                    href="#"
                                    data-toggle="modal"
                                    data-target="#modal-prioridade"
                                    onClick={() => this.priorizar(row.id)}
                                  >
                                    <i
                                      className={`fas fa-circle text-${
                                        row.nivel == 1
                                          ? "primary"
                                          : row.nivel == 2
                                          ? "warning"
                                          : "danger"
                                      }`}
                                    ></i>
                                  </a>
                                ) : (
                                  <i
                                    className={`fas fa-circle text-${
                                      row.nivel == 1
                                        ? "primary"
                                        : row.nivel == 2
                                        ? "warning"
                                        : "danger"
                                    }`}
                                  ></i>
                                ),
                            },
                            {
                              name: "Status",
                              selector: "status",
                              sortable: true,
                              cell: (row) => (
                                <small
                                  class={
                                    row.status == 1
                                      ? "badge badge-danger"
                                      : row.status == 2
                                      ? "badge badge-warning"
                                      : row.status == 3
                                      ? "badge badge-primary"
                                      : row.status == 4
                                      ? "badge badge-secondary"
                                      : row.status == 5 
                                      ? "badge badge-secondary" 
                                      : "badge badge-success"
                                  }
                                >
                                  {status[row.status - 1].label}{" "}
                                </small>
                              ),
                            },

                            {
                              name: "Data",
                              selector: "emissao",
                              sortable: true,
                              cell: (row) => dateUtils(row.emissao),
                            },

                            {
                              name: "Cliente",
                              selector: "cliente",
                              sortable: true,
                              cell: (row) => 
                                <a href="#"  data-dismiss="modal"
                                  data-toggle="modal"
                                  data-target="#modal-atendimento"
                                  onClick={() => this.atendimento(row)}>
                                  {row.cliente}
                                </a>,
                              
                              
                            },
                            {
                              name: "Pronto",
                              selector: "pronto",
                              sortable: true,
                              cell: (row) => row.pronto ? dateUtils(row.pronto) : null,
                            },
                            {
                              name: "Acrescimo",
                              selector: "acrescimo",
                              sortable: true,
                              cell: (row) =>
                                row.acrescimo
                                  ? row.acrescimo.toFixed(2)
                                  : "0.00",
                            },
                            {
                              name: "Desconto",
                              selector: "desconto",
                              sortable: true,
                              cell: (row) =>
                                row.desconto ? row.desconto.toFixed(2) : "0.00",
                            },
                            {
                              name: "Total",
                              selector: "total",
                              sortable: true,
                              cell: (row) =>
                                row.total ? row.total.toFixed(2) : "0.00",
                            },
                            {
                              name: "Menu",
                              selector: "impressao",
                              sortable: true,
                              cell: (row) => (
                                <div class="btn-group">
                                  <button
                                    id="editar"
                                    className="btn btn-default"
                                    data-toggle="modal"
                                    data-target="#modal-opcao"
                                    onClick={() => {
                                      this.opcaoMenu(row);
                                    }}
                                  >
                                    <i class="fas fa-align-justify"></i>
                                  </button>
                                </div>
                              ),
                            },
                          ]}
                          data={this.state.items}
                          dense="false"
                          noHeader="false"
                          pagination
                          subHeader
                          subHeaderComponent={subHeaderComponentMemo}
                        />
                      </div>
                      <div class="modal fade" id="modal-prioridade">
                        <div class="modal-dialog modal-sm">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h4 class="modal-title">Prioridade</h4>
                              <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div class="form-group">
                                <label>Prioridade</label>
                                <Select
                                  id="prioridade"
                                  placeholder="Selecione"
                                  options={this.state.listaPrioridade}
                                  defaultValue={
                                    this.state.listaPrioridade[this.state.nivel]
                                  }
                                  onChange={(e) =>
                                    this.setState({ nivel: e.value })
                                  }
                                />
                              </div>
                            </div>
                            <div class="modal-footer justify-content-between">
                              <button
                                type="button"
                                class="btn btn-success"
                                data-dismiss="modal"
                                onClick={(e) =>
                                  this.nivel(this.state.id, this.state.nivel)
                                }
                              >
                                Gravar
                              </button>
                              <button
                                type="button"
                                class="btn btn-danger"
                                data-dismiss="modal"
                              >
                                Abortar
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="modal fade" id="modal-pagamento">
                        <div class="modal-dialog modal-lg">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h4 class="modal-title">Pagamento</h4>
                              <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div class="row">
                                <div class="col-sm-6">
                                  <label>Condição de Pagamento</label>
                                  <Select
                                    id="servico"
                                    placeholder="Selecione"
                                    isSearchable="true"
                                    isOptionSelected
                                    isDisabled={
                                      this.state.totalAberto ===
                                      this.state.totalPago
                                    }
                                    options={this.state.meioPagamentos}
                                    onChange={(e) =>
                                      this.setState({ meioPagamento: e.value })
                                    }
                                  />
                                </div>
                                <div class="col-sm-3">
                                  <div class="form-group">
                                    <label>Recebimento</label>
                                    <input
                                      type="text"
                                      id="pago"
                                      name="pago"
                                      class="form-control"
                                      placeholder="Informe o valor pago"
                                      value={this.state.valor_pago}
                                      onChange={(e) =>
                                        this.setState({
                                          valor_pago: moneyMask(e.target.value),
                                        })
                                      }
                                      readOnly={
                                        this.state.totalAberto ===
                                        this.state.totalPago
                                      }
                                    />
                                  </div>
                                </div>
                                <div class="col-sm-3">
                                  <label>&nbsp;&nbsp;</label>
                                  <button
                                    type="button"
                                    class="btn btn-block btn-outline-success"
                                    onClick={
                                      this.state.totalAberto ===
                                      this.state.totalPago
                                        ? () => {}
                                        : () =>
                                            this.lancar(
                                              this.state.id,
                                              this.state.valor_pago
                                            )
                                    }
                                  >
                                    Lançar
                                  </button>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-sm-12">
                                  <table class="table table-sm">
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th>Pagamento</th>
                                        <th>Valor</th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.item_pagos.map((item, i) => (
                                        <tr key={i}>
                                          <td>{i + 1}.</td>
                                          <td>{item.pagamento}</td>
                                          <td>
                                            {item.valor
                                              ? Number(item.valor).toFixed(2)
                                              : "0.00"}
                                          </td>
                                          <td>
                                            <button
                                              id="excluir"
                                              className="btn btn-tool"
                                              onClick={() => {}}
                                            >
                                              <i class="fas fa-trash-alt"></i>
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-sm-6">
                                  <div class="info-box">
                                    <span class="info-box-icon bg-danger elevation-1">
                                      <i class="fas fa-dollar-sign"></i>
                                    </span>

                                    <div class="info-box-content">
                                      <span class="info-box-text">
                                        <h4>Total Fatura</h4>
                                      </span>
                                      <span class="info-box-number">
                                        <h5>{this.state.totalAberto}</h5>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-6">
                                  <div class="info-box">
                                    <span class="info-box-icon bg-info elevation-1">
                                      <i class="fas fa-dollar-sign"></i>
                                    </span>

                                    <div class="info-box-content">
                                      <span class="info-box-text">
                                        <h4>Total Pago</h4>
                                      </span>
                                      <span class="info-box-number">
                                        <h5>{this.state.totalPago}</h5>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="modal-footer justify-content-between">
                              <button
                                type="button"
                                class="btn btn-default"
                                data-dismiss="modal"
                              >
                                Cancelar
                              </button>
                              <button
                                type="button"
                                class="btn btn-primary"
                                onClick={this.pagar}
                                data-dismiss="modal"
                              >
                                Finalizar
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="modal fade" id="modal-opcao">
                        <div class="modal-dialog modal-sm">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h4 class="modal-title">Opções de Menu</h4>
                              <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              {this.state.pedido.status == 1 ? (
                                <button
                                  type="button"
                                  class="btn btn-block btn-outline-primary btn-sm"
                                  data-dismiss="modal"
                                  onClick={() => {
                                    this.aprovacao(this.state.pedido.id);
                                  }}
                                >
                                  Aprovar
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  class="btn btn-block btn-outline-primary btn-sm disabled"
                                >
                                  Aprovar
                                </button>
                              )}
                              {this.state.pedido.status == 1 ? (
                                <button
                                  type="button"
                                  class="btn btn-block btn-outline-primary btn-sm"
                                  data-dismiss="modal"
                                  onClick={() => {
                                    this.cancelar(this.state.pedido.id);
                                  }}
                                >
                                  Cancelar
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  class="btn btn-block btn-outline-primary btn-sm disabled"
                                >
                                  Cancelar
                                </button>
                              )}
                              {this.state.pedido.status == 2 &&
                              !this.state.pedido.meiopagamento ? (
                                <button
                                  type="button"
                                  class="btn btn-block btn-outline-primary btn-sm"
                                  data-dismiss="modal"
                                  data-toggle="modal"
                                  data-target="#modal-pagamento"
                                  onClick={() =>
                                    this.lancamentos(this.state.pedido)
                                  }
                                >
                                  Pagamento Antecipado
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  class="btn btn-block btn-outline-primary btn-sm disabled"
                                >
                                  Pagamento Antecipado
                                </button>
                              )}
                              {this.state.pedido.status == 2 ? (
                                <button
                                  type="button"
                                  class="btn btn-block btn-outline-primary btn-sm"
                                  data-dismiss="modal"
                                  onClick={() =>
                                    this.producao(this.state.pedido.id)
                                  }
                                >
                                  Produção
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  class="btn btn-block btn-outline-primary btn-sm disabled"
                                >
                                  Produção
                                </button>
                              )}
                              {this.state.pedido.status == 3 ? (
                                <button
                                  type="button"
                                  class="btn btn-block btn-outline-primary btn-sm"
                                  data-dismiss="modal"
                                  onClick={() =>
                                    this.produzido(this.state.pedido.id)
                                  }
                                >
                                  Conclusão
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  class="btn btn-block btn-outline-primary btn-sm disabled"
                                >
                                  Conclusão
                                </button>
                              )}

                              {
                              this.state.pedido.status == 4 ? (
                                <button
                                  type="button"
                                  class="btn btn-block btn-outline-primary btn-sm"
                                  data-dismiss="modal"
                                  data-toggle="modal"
                                  data-target="#modal-pagamento"
                                  onClick={() =>
                                    this.lancamentos(this.state.pedido)
                                  }
                                >
                                  Efetuar Pagamento
                                </button>
                              ) : this.state.pedido.status == 5 ? (
                                <button
                                  type="button"
                                  class="btn btn-block btn-outline-primary btn-sm"
                                  data-dismiss="modal"
                                  data-toggle="modal"
                                  onClick={ () => {
                                    this.concluir(this.state.pedido.id)
                                  }}
                                >
                                  Concluir Atendimento
                                </button>
                              ) : 
                              (
                                <button
                                  type="button"
                                  class="btn btn-block btn-outline-primary btn-sm disabled"
                                >
                                  Efetuar Pagamento
                                </button>
                              )
                              }
                              <button
                                type="button"
                                class="btn btn-block btn-outline-primary btn-sm"
                                data-dismiss="modal"
                                onClick={() =>
                                  this.imprimir(this.state.pedido.id)
                                }
                              >
                                Imprimir Cupom
                              </button>
                            </div>
                            <div class="modal-footer justify-content-between">
                              <button
                                type="button"
                                class="btn btn-danger"
                                data-dismiss="modal"
                              >
                                Abortar
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="modal fade" id="modal-cliente">
                        <div class="modal-dialog modal-lg">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h4 class="modal-title">Cadastro de cliente</h4>
                              <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div class="row"> 
                                <div class="col-sm-12">
                                  {
                                  this.state.isCustomerValide ?
                                    <div class="alert alert-danger alert-dismissible">
                                        <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                                        <h5><i class="icon fas fa-ban"></i> Ops!</h5>
                                        Informe os dados obrigatório cnpj/cpf, razão/nome, fantasia/apelido e um telefone de contato.
                                    </div> : ''
                                }
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-sm-3">
                                  <label>CNPJ ou CPF</label>
                                    <input
                                      type="text"
                                      id="cpf"
                                      name="cpf"
                                      class="form-control"
                                      placeholder="Informe o cnpj ou cpf"
                                      value={ this.state.cnpjcpf} onChange={ e => this.setState({ cnpjcpf: e.target.value.length >= 13 ? cnpjMask(e.target.value) : cpfMask(e.target.value) })}
                                      required
                                    />
                                </div>
                                <div class="col-sm-5">
                                  <label>Razão/Nome</label>
                                    <input
                                      type="text"
                                      id="razao"
                                      name="razao"
                                      class="form-control"
                                      placeholder="Informe a razão social ou nome do cliente"
                                      value={ this.state.razao } onChange={ e => this.setState({ razao: e.target.value})} 
                                      required
                                     
                                    />
                                </div>
                                <div class="col-sm-4">
                                  <label>Fantasia/Apelido</label>
                                    <input
                                      type="text"
                                      id="fantasia"
                                      name="fantasia"
                                      class="form-control"
                                      placeholder="Informe o nome fantasia ou apelido"
                                      value={ this.state.fantasia } onChange={ e => this.setState({ fantasia: e.target.value})} 
                                      required
                                     
                                    />
                                </div>
                              </div>
                              <div class="row">
                                  <div class="col-sm-2">
                                      <div class="form-group">
                                          <label>Cep</label>
                                          <input 
                                            type="text" 
                                            class="form-control" 
                                            placeholder="Cep do registro"
                                            value={ this.state.cep } 
                                            onChange={e => this.onChargeCep(cepMask(e.target.value))} 
                                          />
                                      </div>
                                  </div>
                                  <div class="col-sm-8">
                                      <div class="form-group">
                                          <label>Endereço</label>
                                          <input type="text" class="form-control"  placeholder="Endereço do registro" value={ this.state.endereco } onChange={ e => this.setState({ endereco: e.target.value })} />
                                      </div>
                                  </div>
                                  <div class="col-sm-2">
                                      <div class="form-group">
                                          <label>Número</label>
                                          <input type="text" class="form-control"   placeholder="Número do registro" value={ this.state.numero } onChange={ e => this.setState({ numero: e.target.value })}/>
                                      </div>
                                  </div>
                              </div>
                              <div class="row">
                                  <div class="col-sm-12">
                                      <div class="form-group">
                                          <label>Complemento</label>
                                          <input type="text" class="form-control" placeholder="Complemento do registro" value={ this.state.complemento } onChange={ e => this.setState({ complemento: e.target.value })}/>
                                      </div>
                                  </div>
                              </div>
                              <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Uf</label>
                                        <Select
                                            id="uf"
                                            placeholder="Selecione" 
                                            isSearchable="true"
                                            isOptionSelected
                                            value={this.state.ufDefault}
                                            options={ this.state.ufs } 
                                            onChange={ e => this.setState({uf: e.value, ufDefault:[{label: e.label, value: e.value }] })}
                                           
                                        />

                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Cidade</label>
                                        <input type="text" class="form-control" placeholder="Cidade do registro"  value={ this.state.cidade } onChange={e => this.setState({ cidade:e.target.value })}/>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Bairro</label>
                                        <input type="text" class="form-control" placeholder="Cidade do registro" value={ this.state.bairro } onChange={e => this.setState({ bairro:e.target.value })}/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                              <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>E-mail</label>
                                        <input type="email" class="form-control" placeholder="E-mail do registro" value={ this.state.email } onChange={e => this.setState({ email:e.target.value })}/>
                                    </div>
                                </div>
                            
                                
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Fone</label>
                                        <input type="text" class="form-control"  placeholder="Fone do registro" value={ this.state.fone } onChange={e => this.setState({ fone: foneMask(e.target.value) })} required/>
                                    </div>
                                </div>
                            </div>
                             
                            </div>
                            <div class="modal-footer justify-content-between">
                              <button
                                type="button"
                                class="btn btn-danger"
                                data-dismiss="modal"
                              >
                                Cancelar
                              </button>
                              <button
                                type="button"
                                class="btn btn-primary"  
                                onClick={ this.salvarNovoCliente } 
                                data-dismiss={ this.state.isCustomerValide ? "modal" : "" }    
                                                    
                              >
                                Salvar
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="modal fade" id="modal-atendimento">
                        <div class="modal-dialog modal-lg">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h4 class="modal-title">Atendimento ao Cliente</h4>
                              <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div class="row">
                                <div class="col-sm-12">
                                  <label>Motivo</label>
                                  <Select
                                    id="motivo"
                                    placeholder="Selecione"
                                    isSearchable="true"
                                    isOptionSelected
                                    value={this.state.motivoDefault}
                                    options={ this.state.motivos } 
                                    onChange={ e => this.setState({motivo_atendimento: e.value, motivoDefault:[{label: e.label, value: e.value }] })}
                                   
                                  />
                                </div>
                                <div class="col-sm-12">
                                  <div class="form-group">
                                    <label>Descrição</label>
                                    <textarea
                                      class="form-control"
                                      rows="3"
                                      placeholder="Descreva o motivo"
                                      value={this.state.descricao_atendimento}
                                      onChange={(e) =>
                                        this.setState({
                                          descricao_atendimento: e.target.value,
                                        })
                                      }
                                      
                                    ></textarea>
                                  </div>
                                </div>                                
                              </div>
                              <div className="row">
                                <div class="col-sm-12">
                                  <table class="table table-sm">
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th>Data</th>
                                        <th>Hora</th>
                                        <th>Motivo</th>
                                        <th>Descrição</th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.eventos_atendimento.map((item, i) => (
                                        <tr key={i}>
                                          <td>{i + 1}.</td>
                                          <td>{moment(item.data).format('DD/MM/yyyy')}</td>
                                          <td>{item.hora.split(".")[0]}</td>
                                          <td>{item.motivo}</td>
                                          <td>{item.observacao}</td>
                                        </tr>
                                      ))}                          
                                    </tbody>
                                  </table>                                  
                                </div>                                
                              </div>
                            </div>
                            <div class="modal-footer justify-content-between">
                              <button
                                type="button"
                                class="btn btn-default"
                                data-dismiss="modal"
                              >
                                Fechar
                              </button>

                              <button
                                    type="button"
                                    class="btn btn-success"
                                    data-dismiss="modal"
                                    onClick={() => {
                                      this.salvarAtendimento()
                                    }}>
                                  salvar
                              </button>
                              
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.state.isLoading ? (
                        <div class="overlay d-flex justify-content-center align-items-center">
                          <i class="fas fa-2x fa-sync fa-spin"></i>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export default Vendas;
